// CANVAS KÉO THẢ cho sơ đồ NHIỀU MẠNG trong một kịch bản — thành phần ĐỘC LẬP (chưa nối vào trang Kịch bản; lượt sau trang kich-ban.ts gọi taoSoDoCanvas rồi nối `cb` với API đồ thị).
// DOM thuần dựng bằng h()/svg(), không thư viện. Dựa trên bản mẫu kichban-quay/prototype-so-do/so-do-mau.html (hình dạng + tương tác người dùng đã duyệt).
//
// Dữ liệu: đồ thị = các ĐƯỜNG rời nhau (src/shared/do-thi.ts: mỗi ô vào ≤ 1, ra ≤ 1, không vòng). Bố cục (x, y) NẰM NGOÀI sơ đồ: thành phần nhận `boCuc` và phát `cb.thayDoiBoCuc`.
// Thành phần giữ BẢN SAO trạng thái {nut, canh, boCuc}; mọi thay đổi người dùng làm → cập nhật bản sao + vẽ lại ĐÚNG ô/cạnh bị ảnh hưởng + gọi `cb`. Trang chủ gọi capNhat(opts) để đưa dữ liệu thật vào (khớp thì không vẽ lại).
// Luật hiển thị: chữ người dùng gõ (tên ô, tham số, lý do cờ) LUÔN vào textContent / thuộc tính — không bao giờ innerHTML. huy() gỡ MỌI trình nghe, hẹn giờ, ResizeObserver.
import type { CanhDoThi, CanhLap, LapCaSoDo, NutDoThi } from "../../../../src/shared/do-thi";
import { GIOI_HAN_DO_THI } from "../../../../src/shared/do-thi";
import { h, svg, toast } from "../dom";
import {
  CAO_O, LichSu, RONG_O, bacLap, boundsCua, chuLapCaSoDo, chuUoc, chuanHoaCanh, chuanHoaLap, chuanHoaView, datViTriThieu, dichO, docSoLan, heSoVong, hinhHocCanh, hinhHocLap, hinhHocTam,
  cacNhanhKhac, chuTanSuat, kiemLap, kiemNoi, kiemThemO, kiemXoaCanh, laNoiNguoc, maMang, mucCo, nhanAria, nhanLap, soDuong, tachDuong, thuTuDoc, tuDan, themO, khungDauHep, vuaKhung, xoaO, zoomChum, zoomQuanh,
  type BoCuc, type CanhBaoNut, type TrangThai, type View, type ViTri,
} from "../so-do-canvas-mo-hinh";

export type { BoCuc, CanhBaoNut, ViTri };

// ================= API CÔNG KHAI =================
export interface DanhMucMang { nenTang: string; ten?: string; thaoTac: { ma: string; ten: string }[] }
export interface YeuCauThemNut {
  /** Mã thao tác người dùng đã chọn trong menu; không có `danhMuc` thì để trống — trang chủ tự hỏi. */
  thaoTac?: string;
  /** Mạng người dùng chọn trong menu (nếu có). */
  nenTang?: string;
  /** Nối ĐUÔI ô này (đã có ô kế → chèn vào giữa). */
  sauNutId?: string;
  /** Chèn vào giữa nối này. */
  truocCanh?: CanhDoThi;
  /** Chỗ gợi ý (toạ độ thế giới, góc trên-trái ô). */
  viTri: ViTri;
}
type KqNut = NutDoThi | null | undefined;
export interface CbSoDoCanvas {
  /** Danh sách cạnh MỚI (toàn bộ) sau mỗi thay đổi nối: nối, gỡ nối, chèn, xoá ô tự nối lại, hoàn tác / làm lại. */
  thayDoiCanh?(canh: CanhDoThi[]): void;
  /** Bố cục MỚI (toàn bộ) sau khi kéo ô xong, dịch bằng phím, Tự dàn, thêm/xoá ô, hoàn tác. */
  thayDoiBoCuc?(boCuc: BoCuc): void;
  /** Bấm đúp / Enter trên ô: trang chủ mở form tham số. */
  moChiTiet?(nutId: string): void;
  /** Tạo ô mới ở dữ liệu thật (cấp mã, tham số mặc định) và TRẢ VỀ ô đó; null/undefined = từ chối (thành phần không thêm gì). Có thể async. */
  themNut?(yc: YeuCauThemNut): KqNut | Promise<KqNut>;
  /** Xoá ô khỏi dữ liệu thật (thành phần tự nối lại hai đầu rồi gọi thayDoiCanh). Cũng được gọi khi HOÀN TÁC một lần thêm ô. */
  xoaNut?(nutId: string): void;
  /** Đưa lại ô đã xoá (nguyên nội dung) khi HOÀN TÁC một lần xoá / LÀM LẠI một lần thêm. Không khai → không hoàn tác được thao tác đổi tập ô. */
  khoiPhucNut?(nut: NutDoThi): void;
  /** Nhân bản ô: trả về bản sao (ô mới chèn ngay SAU ô gốc trong đường). */
  nhanBan?(nutId: string): KqNut | Promise<KqNut>;
  /** Bật/tắt "điểm nhường" của ô Nghỉ (thành phần cũng đổi ngay trên màn hình — lạc quan). */
  doiNhuong?(nutId: string): void;
  /** (07/10/2026) Danh sách VÒNG LẶP mới (toàn bộ) sau mỗi lần tạo / sửa / gỡ vòng, xoá ô chạm vòng, hoàn tác / làm lại. */
  thayDoiLap?(lap: CanhLap[]): void;
  /** (07/10/2026) "Lặp cả sơ đồ" mới (null = bỏ). */
  thayDoiLapCaSoDo?(lc: LapCaSoDo | null): void;
  /** (08/10/2026, đợt A) Đặt / bỏ (null) "Dành cho" của bước Nghỉ (mã bước đầu nhánh được gán). */
  datDanhCho?(nutId: string, danhCho: string | null): void;
  /** (đợt A) Đặt / bỏ (null) tần suất của bước việc. */
  datTanSuat?(nutId: string, tanSuat: NutDoThi["tanSuat"] | null): void;
}
export interface TuyChonSoDoCanvas {
  nut: NutDoThi[];
  /** Thiếu = một chuỗi theo thứ tự `nut` (như do-thi.ts). */
  canh?: CanhDoThi[];
  /** Thiếu / hỏng / NaN từng ô → tự dàn bù. */
  boCuc?: BoCuc;
  /** Mã thao tác → mạng ("facebook" | "youtube" | "tiktok" | "x" | "reddit" | …). `nut.nenTang` (nếu có) thắng. */
  thaoTacMang: (thaoTac: string, nut?: NutDoThi) => string | undefined | null;
  tomTatNut: (nut: NutDoThi) => string;
  tenNut: (nut: NutDoThi) => string;
  /** Cờ của ô: "vang" (nên xem lại) / "do" (sẽ không chạy) + lý do. */
  canhBao?: (nutId: string) => CanhBaoNut[];
  /** (08/10/2026) Ô LỖI trong lần chạy gần nhất → câu dễ hiểu (dấu ✗ đỏ góc ô + chú thích khi rê chuột); null = không lỗi. Lần sau chạy đạt → máy chủ trả ok → dấu tự hết. */
  loiChay?: (nutId: string) => string | null;
  /** Nhãn phụ như "lần 2" (danhNhanLan). */
  danhNhan?: (nutId: string) => string | null | undefined;
  cb?: CbSoDoCanvas;
  /** Chỉ xem: không kéo ô, không nối, không thêm/xoá; vẫn kéo nền / zoom / mở chi tiết. */
  chiDoc?: boolean;
  /** Danh mục cho menu "Thêm ô" (mạng → thao tác). Không có → bấm "Thêm ô" gọi thẳng cb.themNut không kèm `thaoTac`. */
  danhMuc?: DanhMucMang[];
  /** Mạng mặc định của đồ thị (khi ô không khai `nenTang` và thaoTacMang không biết). */
  nenTangMacDinh?: string;
  /** Ô có phải ô Nghỉ không (mặc định thaoTac === "nghi"). */
  laNghi?: (nut: NutDoThi) => boolean;
  /** Mặc định cho cờ `nhuong` của ô Nghỉ không khai riêng: không đặt = bật khi có ≥ 2 đường (như do-thi.ts). */
  nhuongMacDinh?: boolean;
  /** Biểu tượng của ô: "tim" | "nguoi" | "dong-ho" | "cuon" | "binh-luan" | "thich" | "but" | "chung"; mặc định đoán từ mã thao tác. */
  bieuTuong?: (nut: NutDoThi) => string;
  /** true = mở ở chế độ danh sách dọc; false = canvas; thiếu = tự chọn (danh sách khi màn hình ≤ 640 px). */
  danhSachDoc?: boolean;
  /** Thông báo ngắn (mặc định toast() của trang). */
  thongBao?: (text: string, kind: "info" | "err" | "warn") => void;
  /** (07/10/2026) Vòng lặp "Quay lại" (cạnh cam cong phía dưới; thiếu = không có vòng). */
  lap?: CanhLap[];
  /** (07/10/2026) Lặp cả sơ đồ (null / thiếu = không lặp). */
  lapCaSoDo?: LapCaSoDo | null;
  /** (07/10/2026) Ước lượng giây của MỘT lần chạy ô (chữ "~45 giây" / Nghỉ "1–3 phút" dưới ô; thành phần tự nhân ×N theo vòng lặp chứa ô). */
  uocNut?: (nut: NutDoThi) => { tuS: number; denS: number } | null | undefined;
  /** (07/10/2026) Chữ TỔNG thời gian ước chừng cho thanh công cụ ("Cả sơ đồ ~25–40 phút · Chạy thử ~3 phút"). */
  tongUoc?: () => string;
  /** (08/10/2026, đợt A) Phần tử của trang đặt ở GÓC DƯỚI PHẢI khung vẽ, ngay bên trái cụm zoom (nút đỏ "Hẹn giờ chạy"). Ẩn khi chỉ đọc. */
  henGio?: HTMLElement | null;
  /** (08/10/2026) chỉ báo trạng thái lưu + nút "Lưu" của trang — đặt NGAY cạnh Hoàn tác / Làm lại trên thanh công cụ. */
  luuEl?: HTMLElement | null;
}
export interface SoDoCanvas {
  /** Đưa dữ liệu / cấu hình mới (chỉ các khoá có trong `o` đổi). Nội dung khớp bản đang vẽ thì không vẽ lại. */
  capNhat(o: Partial<TuyChonSoDoCanvas>): void;
  /** Chọn + đưa tiêu điểm tới ô (cuộn vào khung nếu ở ngoài). null = bỏ chọn. */
  chonNut(id: string | null): void;
  /** Vẽ lại toàn bộ từ dữ liệu hiện có (tự sửa vị trí hỏng). */
  dongBo(): void;
  /** Gỡ mọi trình nghe / hẹn giờ / ResizeObserver và xoá DOM của thành phần. Gọi nhiều lần cũng được. */
  huy(): void;
  /** Phần tử danh sách dọc dự phòng (đường → ô theo thứ tự chạy), đã vẽ theo dữ liệu hiện có; luôn cập nhật khi dữ liệu đổi. */
  laySoDoDoc(): HTMLElement;
  vuaKhung(): void;
  tuDan(): void;
  hoanTac(): void;
  lamLai(): void;
  layBoCuc(): BoCuc;
  layCanh(): CanhDoThi[];
  /** (07/10/2026) Vòng lặp hiện có + lặp cả sơ đồ. */
  layLap(): CanhLap[];
  layLapCaSoDo(): LapCaSoDo | null;
  layNut(): NutDoThi[];
  layView(): View;
}

// ================= HẰNG SỐ / TIỆN ÍCH =================
const W = RONG_O, H = CAO_O;
let demThe = 0;
const hh = (v: number): boolean => Number.isFinite(v);
const lopCo = (m: "vang" | "do" | null): string => (m === "do" ? "lv-do" : m === "vang" ? "lv-vang" : "lv-ok");

const BIEU_TUONG: Record<string, [string, Record<string, string>][]> = {
  tim: [["circle", { cx: "11", cy: "11", r: "7" }], ["path", { d: "M16.5 16.5 21 21" }]],
  nguoi: [["circle", { cx: "9", cy: "8", r: "4" }], ["path", { d: "M2 20c0-4 3-6 7-6s7 2 7 6M19 7v6M16 10h6" }]],
  "dong-ho": [["circle", { cx: "12", cy: "12", r: "9" }], ["path", { d: "M12 7v5l3 2" }]],
  cuon: [["path", { d: "M12 4v16M8 8l4-4 4 4M8 16l4 4 4-4" }]],
  "binh-luan": [["path", { d: "M4 5h16v11H9l-5 4z" }]],
  thich: [["path", { d: "M7 11v9H4v-9zM7 11l4-7c1.6 0 2.6 1.1 2.3 2.6L12.8 10H19a2 2 0 0 1 2 2.3l-1.2 6A2 2 0 0 1 17.8 20H7" }]],
  but: [["path", { d: "M4 20l4-1 11-11-3-3L5 16z" }]],
  chung: [["rect", { x: "5", y: "5", width: "14", height: "14", rx: "3" }]],
};
function doanBieuTuong(thaoTac: string): string {
  const t = thaoTac.toLowerCase();
  if (/nghi|rest|wait/.test(t)) return "dong-ho";
  if (/tim|search|find|kiem/.test(t)) return "tim";
  if (/binh_luan|comment|tra_loi|reply/.test(t)) return "binh-luan";
  if (/thich|like|react/.test(t)) return "thich";
  if (/luot|cuon|scroll|xem/.test(t)) return "cuon";
  if (/tham_gia|join|theo_doi|follow|ket_ban/.test(t)) return "nguoi";
  if (/dang|post|viet|tao_bai/.test(t)) return "but";
  return "chung";
}
function veBieuTuong(ten: string, lop = "sdc-bt"): SVGSVGElement {
  const ds = BIEU_TUONG[ten] ?? BIEU_TUONG.chung!;
  const s = svg("svg", { viewBox: "0 0 24 24", class: lop, "aria-hidden": "true", focusable: "false" });
  for (const [tag, a] of ds) s.appendChild(svg(tag as "path", a));
  return s;
}
/**
 * (07/10/2026) Cờ "nên xem lại" = TAM GIÁC viền vàng nhỏ ⚠; cờ "sẽ không chạy" = HÌNH TRÒN VÀNG ĐẶC viền đỏ có CHẤM THAN (!) — đặt ở GÓC DƯỚI ô. Hai hình khác nhau (người mù màu vẫn phân biệt),
 * khác huy hiệu tròn của mạng (huy hiệu không có viền đỏ / chấm than), và KHÔNG còn dấu ✕ (✕ ở góc trên phải giờ là nút XOÁ ô thật). Dùng chung cho thanh tổng cờ của trang.
 */
export function veCo(muc: "vang" | "do"): SVGSVGElement {
  const s = svg("svg", { viewBox: "0 0 24 24", class: `sdc-co sdc-co-${muc}`, "aria-hidden": "true", focusable: "false" });
  if (muc === "vang") {
    s.appendChild(svg("path", { class: "sdc-co-vien", d: "M12 2 23 21H1z" }));
    s.appendChild(svg("path", { class: "sdc-co-than", d: "M12 2 23 21H1z" }));
    s.appendChild(svg("path", { class: "sdc-co-dau", d: "M12 9v6" }));
    s.appendChild(svg("circle", { class: "sdc-co-cham", cx: "12", cy: "18", r: "1.4" }));
  } else {
    s.appendChild(svg("circle", { class: "sdc-co-vien", cx: "12", cy: "12", r: "11.5" }));
    s.appendChild(svg("circle", { class: "sdc-co-than", cx: "12", cy: "12", r: "10" }));
    s.appendChild(svg("path", { class: "sdc-co-dau", d: "M12 6.2v7.6" }));
    s.appendChild(svg("circle", { class: "sdc-co-cham", cx: "12", cy: "17.6", r: "1.6" }));
  }
  return s;
}

interface ElNut { el: HTMLElement; ten: HTMLElement; tt: HTMLElement; hh: HTMLElement; bt: HTMLElement; lan: HTMLElement; coBox: HTMLElement; loi: HTMLElement; uoc: HTMLElement; gan: HTMLElement; xoa: HTMLButtonElement; sig: string }
interface ElLap { key: string; path: SVGPathElement; hit: SVGPathElement; nhan: HTMLButtonElement; d: string }
interface ElCanh { key: string; hit: SVGPathElement; path: SVGPathElement; ui: HTMLElement; nhan: HTMLElement; btn: HTMLButtonElement; d: string }

// ================= THÀNH PHẦN =================
export function taoSoDoCanvas(host: HTMLElement, opts: TuyChonSoDoCanvas): SoDoCanvas {
  const uid = ++demThe;
  const idGoiY = `sdc-goi-y-${uid}`, idTip = `sdc-tip-${uid}`;
  let o: TuyChonSoDoCanvas = { ...opts };
  let daHuy = false;

  // ---------- trạng thái ----------
  let tt: TrangThai & { lap: CanhLap[] } = { nut: [], canh: [], boCuc: {}, lap: [] };
  let lapCa: LapCaSoDo | null = null;
  let heSo = new Map<string, number>(); // hệ số nhân thời gian của ô theo vòng lặp chứa ô
  let view: View = { k: 1, tx: 0, ty: 0 };
  let sel: string | null = null;
  let nguonNoi: string | null = null;
  let keoId: string | null = null;
  let cheDoDanhSach = false;
  let choVuaKhung = true;
  let lanDauVua = true; // lần vừa khung đầu tiên trên màn hẹp giữ chữ đọc được (xem khungDauHep); các lần bấm nút sau luôn vừa trọn
  let dangThem = false;
  const ls = new LichSu<TrangThai>();
  const elNut = new Map<string, ElNut>();
  const elCanh = new Map<string, ElCanh>();
  const elLap = new Map<string, ElLap>();
  let tweenRaf = 0, tweenXong: (() => void) | null = null, miniRaf = 0, snackHen = 0;
  const hen: number[] = [];

  // ---------- trình nghe có theo dõi ----------
  const dangKy: (() => void)[] = [];
  const nghe = (t: EventTarget, loai: string, fn: (e: never) => void, op?: AddEventListenerOptions | boolean): void => {
    t.addEventListener(loai, fn as EventListener, op);
    dangKy.push(() => t.removeEventListener(loai, fn as EventListener, op));
  };

  // ---------- đọc dữ liệu ----------
  const tenO = (n: NutDoThi): string => { try { return o.tenNut(n) || n.id; } catch { return n.id; } };
  const tenId = (id: string): string => { const n = tt.nut.find((x) => x.id === id); return n ? tenO(n) : id; };
  const nenTangCua = (n: NutDoThi): string | undefined => n.nenTang ?? (o.thaoTacMang(n.thaoTac, n) || undefined) ?? o.nenTangMacDinh;
  const laNghi = (n: NutDoThi): boolean => (o.laNghi ? o.laNghi(n) : n.thaoTac === "nghi");
  const nhuongHL = (n: NutDoThi): boolean => laNghi(n) && (n.nhuong ?? o.nhuongMacDinh ?? soDuong(tt.nut, tt.canh) >= 2);
  const canhBaoCua = (id: string): CanhBaoNut[] => { try { return o.canhBao?.(id) ?? []; } catch { return []; } };
  const nhanLan = (id: string): string | null => { try { return o.danhNhan?.(id) ?? null; } catch { return null; } };
  const chiDoc = (): boolean => o.chiDoc === true;
  const thongBao = (text: string, kind: "info" | "err" | "warn" = "info"): void => { live.textContent = text; if (o.thongBao) o.thongBao(text, kind); else toast(text, kind); };
  const vi = (id: string): ViTri => tt.boCuc[id] ?? { x: 0, y: 0 };

  // ================= DỰNG KHUNG =================
  const nutBam = (nhan: string, lopThem: string, fn: () => void, extra: Record<string, unknown> = {}): HTMLButtonElement => {
    const b = h("button", { type: "button", class: `sdc-btn ${lopThem}`.trim(), title: nhan, ...extra }, nhan);
    nghe(b, "click", fn);
    return b;
  };
  const live = h("div", { class: "sdc-sr", role: "status", "aria-live": "polite", "data-testid": "sdc-live" });
  const btnThem = nutBam("＋ Thêm ô", "sdc-sua", () => { const r = btnThem.getBoundingClientRect(); moMenuThem({ cx: r.left, cy: r.bottom, trungTam: true, trove: btnThem }); }, { "data-testid": "sdc-them", title: "Thêm một ô mới vào sơ đồ" });
  const btnVua = nutBam("Vừa khung", "", () => { if (cheDoDanhSach) datCheDo(false); lanDauVua = false; vuaKhungNgay(); }, { "data-testid": "sdc-vua", title: "Thu phóng cho thấy trọn sơ đồ" });
  const btnDan = nutBam("Tự dàn", "sdc-sua", () => { if (cheDoDanhSach) datCheDo(false); tuDanNgay(); }, { "data-testid": "sdc-tu-dan", title: "Xếp lại các ô: mỗi đường một hàng, theo thứ tự chạy (có Hoàn tác)" });
  const btnUndo = nutBam("↶ Hoàn tác", "sdc-sua", () => hoanTac(), { "data-testid": "sdc-hoan-tac", title: "Hoàn tác thao tác gần nhất (Ctrl+Z)" });
  const btnRedo = nutBam("↷ Làm lại", "sdc-sua", () => lamLai(), { "data-testid": "sdc-lam-lai", title: "Làm lại thao tác vừa hoàn tác (Ctrl+Y)" });
  const btnDs = h("button", { type: "button", class: "sdc-btn", role: "switch", "aria-checked": "false", "data-testid": "sdc-ds-doc", title: "Chuyển giữa khung vẽ và danh sách dọc (dễ dùng trên điện thoại, đọc bằng trình đọc màn hình)" });
  nghe(btnDs, "click", () => datCheDo(!cheDoDanhSach));
  const dem = h("span", { class: "sdc-dem", "data-testid": "sdc-dem" });
  const btnLapCa = nutBam("↻ Lặp cả sơ đồ", "sdc-sua", () => moHopLapCa(), { "data-testid": "sdc-lap-ca", title: "Chạy lại cả sơ đồ nhiều vòng, nghỉ giữa các vòng (không bao giờ lặp mãi: tối đa 20 vòng)" });
  const lapCaChu = h("span", { class: "sdc-lap-ca-chu", "data-testid": "sdc-lap-ca-chu" });
  const tongEl = h("span", { class: "sdc-tong-uoc", "data-testid": "sdc-tong-uoc", title: "Thời gian ước chừng của cả lượt (một bot làm một việc một lúc; đường khác chen vào lúc nghỉ; tính cả vòng lặp)" });
  const thanh = h("div", { class: "sdc-bar", role: "toolbar", "aria-label": "Công cụ sơ đồ" }, btnThem, btnVua, btnDan, btnUndo, btnRedo, ...(o.luuEl ? [o.luuEl] : []), btnLapCa, lapCaChu, h("span", { class: "sdc-gian" }), tongEl, dem, btnDs);

  const markerId = (k: string): string => `sdc-m-${k}-${uid}`;
  const mui = (k: string, rong: number): SVGMarkerElement => {
    const m = svg("marker", { id: markerId(k), markerUnits: "userSpaceOnUse", markerWidth: rong, markerHeight: rong, refX: rong - 1, refY: rong / 2, orient: "auto" });
    m.appendChild(svg("path", { class: `sdc-mui sdc-mui-${k}`, d: `M0 0 ${rong} ${rong / 2} 0 ${rong}z` }));
    return m;
  };
  const gCanh = svg("g", {});
  const dgTam = svg("path", { class: "sdc-tam", d: "" });
  const gLap = svg("g", {});
  const svgCanh = svg("svg", { class: "sdc-canh-svg", "aria-hidden": "true" }, svg("defs", {}, mui("tt", 12), mui("nhuong", 14), mui("lap", 13)), gLap, gCanh, dgTam);
  const boxNut = h("div", { class: "sdc-nuts" });
  const boxUi = h("div", { class: "sdc-ui" });
  const nutMore = h("button", { type: "button", class: "sdc-more", hidden: true, "aria-label": "Thao tác với ô đang chọn", "aria-haspopup": "menu", title: "Thao tác với ô này: nối tới…, chèn ô sau, nhân bản, nhường lượt, xoá", "data-testid": "sdc-more" }, "⋯");
  boxUi.appendChild(nutMore);
  const world = h("div", { class: "sdc-world" }, svgCanh, boxNut, boxUi);
  const vp = h("div", { class: "sdc-vp", tabindex: "-1", role: "application", "aria-label": "Khung vẽ sơ đồ. Kéo nền để di chuyển, cuộn chuột hoặc chụm hai ngón để thu phóng. Dùng Tab để chọn từng ô.", "aria-describedby": idGoiY, "data-testid": "sdc-vp" }, world);
  const banner = h("div", { class: "sdc-banner", hidden: true, role: "status", "data-testid": "sdc-banner" });
  const bannerTxt = h("span", {});
  const bannerHuy = nutBam("Huỷ (Esc)", "sdc-btn-nho", () => datNguonNoi(null), { "data-testid": "sdc-banner-huy" });
  banner.append(bannerTxt, bannerHuy);
  const mini = h("div", { class: "sdc-mini", "aria-label": "Bản đồ nhỏ: bấm hoặc kéo để di chuyển khung nhìn", "data-testid": "sdc-mini" });
  const miniSvg = svg("svg", { role: "img", "aria-label": "Bản đồ nhỏ của sơ đồ" });
  mini.appendChild(miniSvg);
  const zoomLab = h("span", { class: "sdc-zoom-nhan", "data-testid": "sdc-zoom-nhan", "aria-live": "off" }, "100%");
  const zRa = nutBam("−", "sdc-btn-nho", () => zoomGiua(0.8), { "aria-label": "Thu nhỏ", "data-testid": "sdc-zoom-ra" });
  const zVao = nutBam("＋", "sdc-btn-nho", () => zoomGiua(1.25), { "aria-label": "Phóng to", "data-testid": "sdc-zoom-vao" });
  const zoomBox = h("div", { class: "sdc-zoom" }, zRa, zoomLab, zVao);
  const tip = h("div", { class: "sdc-tip", id: idTip, role: "tooltip", hidden: true, "data-testid": "sdc-tip" });
  const snack = h("div", { class: "sdc-snack", hidden: true, role: "status", "data-testid": "sdc-snack" });
  const dsEl = h("div", { class: "sdc-ds", "aria-label": "Danh sách dọc các ô theo thứ tự chạy", "data-testid": "sdc-ds" });
  const henGioBox = h("div", { class: "sdc-hen-gio", "data-testid": "sdc-hen-gio-cho" });
  if (o.henGio) henGioBox.appendChild(o.henGio);
  henGioBox.hidden = !o.henGio || o.chiDoc === true;
  const stage = h("div", { class: "sdc-stage" }, vp, banner, mini, henGioBox, zoomBox, tip, snack, dsEl);
  const menu = h("div", { class: "sdc-menu", role: "dialog", "aria-label": "Menu", hidden: true, "data-testid": "sdc-menu" });
  const goiY = h("div", { id: idGoiY, class: "sdc-sr" }, "Enter hoặc Space: mở chi tiết. Mũi tên: dịch ô 10 điểm (Shift: 40). N: nối tới ô khác. M: thêm thao tác. Ctrl+D: nhân bản. Delete: xoá ô. Ctrl+Z: hoàn tác. Esc: đóng.");
  const root = h("div", { class: "sdc", "data-testid": "sdc", "data-uid": String(uid) }, thanh, stage, menu, goiY, live);
  host.appendChild(root);

  // ================= VIEW =================
  function vpRect(): DOMRect { return vp.getBoundingClientRect(); }
  function datView(v: View): void {
    view = chuanHoaView(v);
    world.style.transform = `translate(${view.tx}px,${view.ty}px) scale(${view.k})`;
    vp.style.backgroundSize = `${24 * view.k}px ${24 * view.k}px`;
    vp.style.backgroundPosition = `${view.tx}px ${view.ty}px`;
    world.style.setProperty("--sdc-ik", String(Math.min(1.9, Math.max(1, 0.85 / view.k)))); // chữ nhỏ / cờ / nút "+" không teo theo zoom
    zoomLab.textContent = `${Math.round(view.k * 100)}%`;
    vp.dataset.k = String(view.k);
    veMini();
    capNhatNutMore();
  }
  function zoomGiua(f: number): void { const r = vpRect(); datView(zoomQuanh(view, r.width / 2, r.height / 2, f)); }
  function vuaKhungNgay(): void {
    if (cheDoDanhSach) { choVuaKhung = true; return; }
    const r = vpRect();
    const v = lanDauVua && r.width <= 640 ? khungDauHep(tt.boCuc, r.width, r.height) : vuaKhung(tt.boCuc, r.width, r.height);
    if (!v) { choVuaKhung = true; return; } // đang ẩn (khung 0×0): chờ ResizeObserver
    choVuaKhung = false; lanDauVua = false;
    datView(v);
  }
  function thanhToaDo(cx: number, cy: number): ViTri { const r = vpRect(); return { x: (cx - r.left - view.tx) / view.k, y: (cy - r.top - view.ty) / view.k }; }
  function hienRoi(id: string): void {
    const p = tt.boCuc[id]; if (!p || cheDoDanhSach) return;
    const r = vpRect(), m = 30;
    const l = view.tx + p.x * view.k, t = view.ty + p.y * view.k, rr = l + W * view.k, bb = t + H * view.k;
    let { tx, ty } = view;
    if (l < m) tx += m - l; else if (rr > r.width - m) tx -= rr - (r.width - m);
    if (t < m) ty += m - t; else if (bb > r.height - m) ty -= bb - (r.height - m);
    if (tx !== view.tx || ty !== view.ty) datView({ k: view.k, tx, ty });
  }

  // ================= VẼ Ô =================
  function taoElNut(id: string): ElNut {
    const hhEl = h("span", { class: "sdc-hh", "aria-hidden": "true" });
    const bt = h("span", { class: "sdc-bt-hop", "aria-hidden": "true" });
    const ten = h("span", { class: "sdc-ten-chu" });
    const lan = h("span", { class: "sdc-lan", hidden: true });
    const ttEl = h("div", { class: "sdc-tt" });
    const coBox = h("span", { class: "sdc-co-box", "aria-hidden": "true" });
    const loi = h("span", { class: "sdc-loi-chay", "data-testid": "sdc-loi-chay", hidden: true }, "✗");
    const uoc = h("span", { class: "sdc-uoc", "aria-hidden": "true", hidden: true });
    const gan = h("span", { class: "sdc-gan", "data-testid": "sdc-gan", hidden: true });
    const xoa = h("button", { type: "button", class: "sdc-xoa", "data-testid": "sdc-xoa-o", "data-id": id, title: "Xoá ô", "aria-label": "Xoá ô" }, "✕");
    boxUi.appendChild(xoa);
    const el = h("div", { class: "sdc-o", tabindex: "0", role: "button", "aria-describedby": idGoiY, "data-id": id, "data-testid": "sdc-o" },
      h("span", { class: "sdc-cong sdc-cong-vao", "data-cong": "vao", "aria-hidden": "true" }),
      hhEl,
      h("div", { class: "sdc-chu" }, h("div", { class: "sdc-ten" }, bt, ten, lan), ttEl),
      coBox, loi,
      h("span", { class: "sdc-nhuong", "aria-hidden": "true" }, "điểm nhường"),
      uoc, gan,
      h("span", { class: "sdc-cong sdc-cong-ra", "data-cong": "ra", "data-testid": "sdc-cong-ra", "aria-hidden": "true" }));
    boxNut.appendChild(el);
    const e: ElNut = { el, ten, tt: ttEl, hh: hhEl, bt, lan, coBox, loi, uoc, gan, xoa, sig: "" };
    elNut.set(id, e);
    return e;
  }
  function veNut(n: NutDoThi, ep = false): void {
    const e = elNut.get(n.id) ?? taoElNut(n.id);
    const mang = maMang(nenTangCua(n));
    const nghi = laNghi(n), nh = nhuongHL(n);
    const cb = canhBaoCua(n.id), co = mucCo(cb);
    const ten = tenO(n);
    let tom = ""; try { tom = o.tomTatNut(n) ?? ""; } catch { tom = ""; }
    const lan = nhanLan(n.id);
    const icon = (() => { try { return o.bieuTuong?.(n) ?? doanBieuTuong(n.thaoTac); } catch { return "chung"; } })();
    const uocChu = uocChuCua(n);
    const ganChu = chuGan(n);
    const loiCau = (() => { try { return o.loiChay?.(n.id) ?? null; } catch { return null; } })();
    const sig = JSON.stringify([ten, tom, mang.ma, mang.chu, nghi, nh, lan, cb, icon, uocChu, ganChu, loiCau]);
    if (!ep && sig === e.sig) return;
    e.sig = sig;
    e.ten.textContent = ten;
    e.tt.textContent = tom; e.tt.title = tom;
    e.hh.textContent = mang.chu; e.hh.classList.toggle("sdc-hh-khong", !mang.chu);
    e.lan.textContent = lan ?? ""; e.lan.hidden = !lan;
    e.bt.replaceChildren(veBieuTuong(icon));
    e.coBox.replaceChildren(...(co ? [veCo(co)] : []));
    e.el.dataset.mang = mang.ma;
    e.el.dataset.co = co ?? "";
    e.loi.hidden = !loiCau; e.loi.title = loiCau ? `Lần chạy gần nhất lỗi: ${loiCau}` : "";
    e.el.dataset.loiChay = loiCau ? "1" : "";
    e.el.setAttribute("aria-label", `${nhanAria({ ten, mang, tomTat: tom, nghi, nhuong: nh, lan, canhBao: cb })}${loiCau ? `. Lần chạy gần nhất lỗi: ${loiCau}` : ""}`);
    e.el.title = `${co ? `${ten}\n${cb.map((c) => c.loi).join("\n")}` : ten}${loiCau ? `\nLần chạy gần nhất lỗi: ${loiCau}` : ""}${uocChu ? `\nƯớc chừng: ${uocChu}` : ""}`;
    e.uoc.textContent = uocChu; e.uoc.hidden = !uocChu;
    e.gan.textContent = ganChu; e.gan.hidden = !ganChu; e.gan.title = ganChu;
    e.xoa.setAttribute("aria-label", `Xoá ô “${ten}”`);
    e.el.className = lopO(n.id);
  }
  function lopO(id: string): string {
    const n = tt.nut.find((x) => x.id === id);
    if (!n) return "sdc-o";
    const mang = maMang(nenTangCua(n));
    const nghi = laNghi(n);
    return `sdc-o net-${mang.ma}${nghi ? " nghi" : ""}${nhuongHL(n) ? " nhuong" : ""} ${lopCo(mucCo(canhBaoCua(id)))}${sel === id ? " sel" : ""}${nguonNoi === id ? " nguon" : ""}${keoId === id ? " keo" : ""}`;
  }
  function veLopTatCa(): void { for (const [id, e] of elNut) { const c = lopO(id); if (e.el.className !== c) e.el.className = c; } }
  function datViTriEl(id: string): void {
    const e = elNut.get(id), p = tt.boCuc[id];
    if (!e || !p) return;
    e.el.style.transform = `translate(${p.x}px,${p.y}px)`;
    e.xoa.style.left = `${p.x + W - 2}px`; e.xoa.style.top = `${p.y - 2}px`; // nút Xoá ô ở GÓC TRÊN PHẢI (nằm ngoài ô: không lồng nút trong nút)
  }
  /** (đợt A) Nhãn phụ dưới bước: bước Nghỉ "dành cho nhánh TikTok" / bước việc có tần suất. */
  function tenNhanhCua(dauId: string): string {
    const ds = tachDuong(tt.nut, tt.canh).find((d) => d.some((x) => x.id === dauId));
    const dau = ds?.[0];
    if (!dau) return dauId;
    const ma = nenTangCua(dau) ?? "";
    return o.danhMuc?.find((m) => m.nenTang === ma)?.ten ?? (ma || tenO(dau));
  }
  function chuGan(n: NutDoThi): string {
    if (laNghi(n) && n.danhCho) return `→ cho nhánh ${tenNhanhCua(n.danhCho)}`;
    if (!laNghi(n) && n.tanSuat) return `⟳ ${chuTanSuat(n.tanSuat)}`;
    return "";
  }
  /** Chữ ước lượng của ô (một lần chạy × số vòng lặp chứa ô). */
  function uocChuCua(n: NutDoThi): string {
    let u: { tuS: number; denS: number } | null | undefined = null;
    try { u = o.uocNut?.(n); } catch { u = null; }
    return chuUoc(u, heSo.get(n.id) ?? 1);
  }

  // ================= VẼ CẠNH =================
  const khoaCanh = (c: CanhDoThi): string => `${c.tu}>${c.den}`;
  function taoElCanh(c: CanhDoThi): ElCanh {
    const key = khoaCanh(c);
    const hit = svg("path", { class: "sdc-hit", "data-canh": key, d: "" });
    const path = svg("path", { class: "sdc-canh", d: "" });
    const nhan = h("span", { class: "sdc-nhan", hidden: true }, "xen kẽ");
    const btn = h("button", { type: "button", class: "sdc-canh-them", "data-canh": key, "data-testid": "sdc-canh-them", "aria-haspopup": "menu", title: "Chèn ô vào giữa nối này (hoặc gỡ nối)" }, "+");
    const ui = h("div", { class: "sdc-eu" }, nhan, btn);
    gCanh.append(hit, path); boxUi.appendChild(ui);
    const e: ElCanh = { key, hit, path, ui, nhan, btn, d: "" };
    elCanh.set(key, e);
    return e;
  }
  function veCanh(c: CanhDoThi, ep = false): void {
    const a = tt.boCuc[c.tu], b = tt.boCuc[c.den];
    const e = elCanh.get(khoaCanh(c)) ?? taoElCanh(c);
    if (!a || !b) return;
    const g = hinhHocCanh(a, b);
    const tu = tt.nut.find((n) => n.id === c.tu), den = tt.nut.find((n) => n.id === c.den);
    const xen = !!tu && nhuongHL(tu);
    if (ep || e.d !== g.d) { e.d = g.d; e.hit.setAttribute("d", g.d); e.path.setAttribute("d", g.d); }
    e.ui.style.left = `${g.mx}px`; e.ui.style.top = `${g.my}px`;
    const lop = `sdc-canh ${xen ? "k-nhuong" : "k-tt"}`;
    if (e.path.getAttribute("class") !== lop) { e.path.setAttribute("class", lop); e.path.setAttribute("marker-end", `url(#${markerId(xen ? "nhuong" : "tt")})`); }
    e.nhan.hidden = !xen;
    const lb = `Chèn ô vào giữa “${tu ? tenO(tu) : c.tu}” và “${den ? tenO(den) : c.den}”`;
    if (e.btn.getAttribute("aria-label") !== lb) e.btn.setAttribute("aria-label", lb);
  }
  function veTatCaCanh(ep = false): void {
    const con = new Set(tt.canh.map(khoaCanh));
    for (const [k, e] of elCanh) if (!con.has(k)) { e.hit.remove(); e.path.remove(); e.ui.remove(); elCanh.delete(k); }
    for (const c of tt.canh) veCanh(c, ep);
  }
  function veCanhCuaO(id: string): void { for (const c of tt.canh) if (c.tu === id || c.den === id) veCanh(c); veTatCaLap(); }

  // ================= VẼ VÒNG LẶP (cạnh cam cong phía dưới, nhãn "lặp ×2" bấm để sửa / gỡ) =================
  const khoaLap = (c: Pick<CanhLap, "tu" | "den">): string => `${c.tu}>${c.den}`;
  function veTatCaLap(): void {
    const con = new Set(tt.lap.map(khoaLap));
    for (const [k, e] of elLap) if (!con.has(k)) { e.path.remove(); e.hit.remove(); e.nhan.remove(); elLap.delete(k); }
    const bac = bacLap(tt.nut, tt.canh, tt.lap);
    for (const c of tt.lap) {
      const key = khoaLap(c);
      let e = elLap.get(key);
      if (!e) {
        const path = svg("path", { class: "sdc-lap", "data-lap": key, d: "" });
        const hit = svg("path", { class: "sdc-hit sdc-hit-lap", "data-lap": key, d: "" });
        const nhan = h("button", { type: "button", class: "sdc-lap-nhan", "data-testid": "sdc-lap-nhan", "data-lap": key, title: "Vòng lặp — bấm để sửa số lần hoặc gỡ vòng" });
        gLap.append(hit, path); boxUi.appendChild(nhan);
        e = { key, path, hit, nhan, d: "" };
        elLap.set(key, e);
      }
      const a = tt.boCuc[c.tu], b = tt.boCuc[c.den];
      if (!a || !b) continue;
      const g = hinhHocLap(a, b, bac.get(key) ?? 0);
      if (e.d !== g.d) { e.d = g.d; e.path.setAttribute("d", g.d); e.hit.setAttribute("d", g.d); e.path.setAttribute("marker-end", `url(#${markerId("lap")})`); }
      e.nhan.style.left = `${g.mx}px`; e.nhan.style.top = `${g.my}px`;
      const chu = nhanLap(c);
      if (e.nhan.textContent !== chu) e.nhan.textContent = chu;
      e.nhan.setAttribute("aria-label", `Vòng lặp: sau “${tenId(c.tu)}” quay lại “${tenId(c.den)}”, ${chu}. Bấm để sửa số lần hoặc gỡ vòng.`);
      e.nhan.title = `Sau “${tenId(c.tu)}” quay lại “${tenId(c.den)}” — ${chu}. Bấm để sửa / gỡ.`;
    }
  }

  // ================= VẼ TẤT CẢ / BẢN ĐỒ NHỎ / ĐẾM =================
  function veTatCa(ep = false): void {
    const con = new Set(tt.nut.map((n) => n.id));
    for (const [id, e] of elNut) if (!con.has(id)) { e.el.remove(); e.xoa.remove(); elNut.delete(id); }
    heSo = heSoVong(tt.nut, tt.canh, tt.lap);
    for (const n of tt.nut) { veNut(n, ep); datViTriEl(n.id); }
    veLopTatCa();
    veTatCaCanh(ep);
    veTatCaLap();
    veDem(); veMini(); capNhatNutMore();
    if (cheDoDanhSach) veDanhSach();
    veNutLenh();
  }
  function veDem(): void {
    dem.textContent = `${tt.nut.length}/${GIOI_HAN_DO_THI.nut} ô · ${soDuong(tt.nut, tt.canh)}/${GIOI_HAN_DO_THI.duong} đường`;
    dem.title = `Tối đa ${GIOI_HAN_DO_THI.nut} ô và ${GIOI_HAN_DO_THI.duong} đường trong một sơ đồ`;
    let tong = ""; try { tong = o.tongUoc?.() ?? ""; } catch { tong = ""; }
    tongEl.textContent = tong; tongEl.hidden = !tong;
    lapCaChu.textContent = chuLapCaSoDo(lapCa);
    btnLapCa.setAttribute("aria-pressed", lapCa ? "true" : "false");
  }
  function veNutLenh(): void {
    const sua = !chiDoc();
    root.classList.toggle("chidoc", !sua);
    const dis = (b: HTMLButtonElement, off: boolean): void => { b.setAttribute("aria-disabled", off ? "true" : "false"); b.classList.toggle("tat", off); };
    dis(btnUndo, !ls.coHoanTac); dis(btnRedo, !ls.coLamLai);
    dis(btnThem, tt.nut.length >= GIOI_HAN_DO_THI.nut);
    btnThem.title = tt.nut.length >= GIOI_HAN_DO_THI.nut ? `Đã đủ ${GIOI_HAN_DO_THI.nut} ô` : "Thêm một ô mới vào sơ đồ";
    btnDs.setAttribute("aria-checked", String(cheDoDanhSach));
    btnDs.textContent = `Danh sách dọc: ${cheDoDanhSach ? "Bật" : "Tắt"}`;
    root.classList.toggle("che-do-ds", cheDoDanhSach);
  }
  function veMini(): void {
    if (miniRaf || daHuy) return;
    miniRaf = requestAnimationFrame(() => {
      miniRaf = 0;
      if (daHuy || cheDoDanhSach) return;
      const r = vpRect(), b = boundsCua(tt.boCuc);
      if (!b || !(r.width > 0) || !(r.height > 0)) { miniSvg.replaceChildren(); return; }
      const v = { x: -view.tx / view.k, y: -view.ty / view.k, w: r.width / view.k, h: r.height / view.k };
      const x0 = Math.min(b.x, v.x) - 30, y0 = Math.min(b.y, v.y) - 30, x1 = Math.max(b.x + b.w, v.x + v.w) + 30, y1 = Math.max(b.y + b.h, v.y + v.h) + 30;
      miniBox = { x0, y0, w: x1 - x0, h: y1 - y0 };
      const kids: SVGElement[] = [];
      for (const c of tt.canh) { const a = tt.boCuc[c.tu], d = tt.boCuc[c.den]; if (a && d) kids.push(svg("line", { class: "sdc-mm-canh", x1: a.x + W, y1: a.y + H / 2, x2: d.x, y2: d.y + H / 2 })); }
      for (const n of tt.nut) {
        const p = tt.boCuc[n.id]; if (!p) continue;
        const co = mucCo(canhBaoCua(n.id));
        kids.push(svg("rect", { class: `sdc-mm-o net-${maMang(nenTangCua(n)).ma}${co ? ` co-${co}` : ""}`, x: p.x, y: p.y, width: W, height: H, rx: 14 }));
      }
      kids.push(svg("rect", { class: "sdc-mm-vp", x: v.x, y: v.y, width: v.w, height: v.h, "vector-effect": "non-scaling-stroke" }));
      miniSvg.setAttribute("viewBox", `${x0} ${y0} ${miniBox.w} ${miniBox.h}`);
      miniSvg.replaceChildren(...kids);
    });
  }
  let miniBox: { x0: number; y0: number; w: number; h: number } | null = null;

  /** Nút "⋯" bám theo ô đang chọn (nằm ngoài ô để không lồng nút trong nút). */
  function capNhatNutMore(): void {
    const p = sel ? tt.boCuc[sel] : undefined;
    const hien = !!p && !cheDoDanhSach;
    nutMore.hidden = !hien;
    if (hien && p) { nutMore.style.left = `${p.x - 8}px`; nutMore.style.top = `${p.y - 12}px`; nutMore.style.transform = `scale(${1 / Math.max(0.6, Math.min(1.4, view.k))})`; }
  }

  // ================= CHỌN / TIÊU ĐIỂM =================
  function chon(id: string | null): void {
    if (sel === id) return;
    const cu = sel; sel = id;
    for (const k of [cu, id]) if (k) { const e = elNut.get(k); if (e) e.el.className = lopO(k); }
    capNhatNutMore();
  }
  function chonNutNgoai(id: string | null): void {
    if (id === null) { chon(null); return; }
    if (!tt.nut.some((n) => n.id === id)) return;
    if (cheDoDanhSach) { chon(id); const li = dsEl.querySelector<HTMLElement>(`[data-id="${CSS.escape(id)}"]`); li?.scrollIntoView({ block: "center" }); li?.querySelector("button")?.focus({ preventScroll: true }); return; }
    chon(id); hienRoi(id); elNut.get(id)?.el.focus({ preventScroll: true });
  }

  // ================= LỊCH SỬ + PHÁT CHO TRANG CHỦ =================
  const chup = (): TrangThai => ({ nut: tt.nut, canh: tt.canh, boCuc: tt.boCuc, lap: tt.lap });
  function phat(canhDoi: boolean, bcDoi: boolean, lapDoi = false): void {
    try {
      if (canhDoi) o.cb?.thayDoiCanh?.(tt.canh.map((c) => ({ ...c })));
      if (bcDoi) o.cb?.thayDoiBoCuc?.(JSON.parse(JSON.stringify(tt.boCuc)) as BoCuc);
      if (lapDoi) o.cb?.thayDoiLap?.(tt.lap.map((c) => ({ ...c })));
    } catch (e) { thongBao(e instanceof Error ? e.message : "Lỗi khi báo thay đổi cho trang", "err"); }
  }
  function ghiLichSu(): void { ls.ghi(chup()); veNutLenh(); }
  /** Đưa trạng thái về `snap` (hoàn tác / làm lại). Ô có nội dung hiện tại thì giữ nội dung hiện tại (không hoàn tác chỗ sửa tham số ở form). */
  function khoiPhuc(snap: TrangThai): void {
    const hien = new Map(tt.nut.map((n) => [n.id, n] as const));
    const trong = new Set(snap.nut.map((n) => n.id));
    const bo = tt.nut.filter((n) => !trong.has(n.id));
    const them = snap.nut.filter((n) => !hien.has(n.id));
    const canhCu = JSON.stringify(tt.canh), bcCu = JSON.stringify(tt.boCuc), lapCu = JSON.stringify(tt.lap);
    // điểm nhường là chuyện của ô nhưng do chính canvas bật/tắt: hoàn tác phải trả cờ về, qua cb.doiNhuong (bật/tắt)
    const doiNhuong: string[] = [];
    // (đợt A) "Dành cho" / tần suất cũng do canvas đặt: hoàn tác trả về qua cb.datDanhCho / cb.datTanSuat
    const doiDanh: [string, string | null][] = [], doiTs: [string, NutDoThi["tanSuat"] | null][] = [];
    tt = { nut: snap.nut.map((n) => {
      const cur = hien.get(n.id); if (!cur) return n;
      let x = cur;
      if ((cur.nhuong ?? null) !== (n.nhuong ?? null) && laNghi(cur)) { doiNhuong.push(n.id); const { nhuong: _bo, ...con } = x; void _bo; x = n.nhuong !== undefined ? { ...con, nhuong: n.nhuong } : con; }
      if ((cur.danhCho ?? null) !== (n.danhCho ?? null)) { doiDanh.push([n.id, n.danhCho ?? null]); const { danhCho: _d, ...con } = x; void _d; x = n.danhCho ? { ...con, danhCho: n.danhCho } : con; }
      if (JSON.stringify(cur.tanSuat ?? null) !== JSON.stringify(n.tanSuat ?? null)) { doiTs.push([n.id, n.tanSuat ?? null]); const { tanSuat: _t, ...con } = x; void _t; x = n.tanSuat ? { ...con, tanSuat: n.tanSuat } : con; }
      return x;
    }), canh: snap.canh, boCuc: snap.boCuc, lap: snap.lap ?? [] };
    try { for (const n of bo) o.cb?.xoaNut?.(n.id); for (const n of them) o.cb?.khoiPhucNut?.(JSON.parse(JSON.stringify(n)) as NutDoThi); for (const id of doiNhuong) o.cb?.doiNhuong?.(id); for (const [id, v] of doiDanh) o.cb?.datDanhCho?.(id, v); for (const [id, v] of doiTs) o.cb?.datTanSuat?.(id, v); } catch (e) { thongBao(e instanceof Error ? e.message : "Lỗi khi hoàn tác", "err"); }
    if (sel && !trong.has(sel)) sel = null;
    if (nguonNoi && !trong.has(nguonNoi)) datNguonNoi(null);
    veTatCa(true);
    phat(JSON.stringify(tt.canh) !== canhCu, JSON.stringify(tt.boCuc) !== bcCu, JSON.stringify(tt.lap) !== lapCu);
  }
  function hoanTac(): void {
    huyCuChi();
    const snap = ls.xemHoanTac();
    if (!snap) { thongBao("Không còn gì để hoàn tác"); return; }
    if (!kiemKhoiPhucDuoc(snap)) return;
    ls.hoanTac(chup()); khoiPhuc(snap); veNutLenh(); thongBao("Đã hoàn tác"); traTieuDiem();
  }
  function lamLai(): void {
    huyCuChi();
    const snap = ls.xemLamLai();
    if (!snap) { thongBao("Không còn gì để làm lại"); return; }
    if (!kiemKhoiPhucDuoc(snap)) return;
    ls.lamLai(chup()); khoiPhuc(snap); veNutLenh(); thongBao("Đã làm lại"); traTieuDiem();
  }
  /** Bấm "Hoàn tác" ở snackbar rồi snackbar biến mất → tiêu điểm rơi ra <body>, phím Ctrl+Z/Y sau đó không tới được thành phần: đưa tiêu điểm về ô đang chọn / khung vẽ. */
  function traTieuDiem(): void {
    const a = document.activeElement;
    if (daHuy || !(a === document.body || a === null || snack.contains(a))) return; // snackbar vừa ẩn: tiêu điểm còn ở nút của nó (trình duyệt chỉ đẩy ra <body> ở nhịp sau)
    if (cheDoDanhSach) { dsEl.querySelector<HTMLElement>("button")?.focus({ preventScroll: true }); return; }
    ((sel ? elNut.get(sel)?.el : undefined) ?? vp).focus({ preventScroll: true });
  }
  function kiemKhoiPhucDuoc(snap: TrangThai): boolean {
    const hien = new Set(tt.nut.map((n) => n.id));
    if (snap.nut.some((n) => !hien.has(n.id)) && !o.cb?.khoiPhucNut) { thongBao("Không hoàn tác được: trang chưa hỗ trợ đưa lại ô đã xoá.", "warn"); return false; }
    return true;
  }
  function snackHienThi(text: string, hoanTacDuoc: boolean): void {
    window.clearTimeout(snackHen);
    snack.replaceChildren(h("span", { class: "sdc-snack-chu" }, text));
    if (hoanTacDuoc) { const b = nutBam("Hoàn tác", "sdc-btn-nho", () => { snack.hidden = true; hoanTac(); }, { "data-testid": "sdc-snack-hoan-tac" }); snack.appendChild(b); }
    snack.hidden = false; live.textContent = text;
    snackHen = window.setTimeout(() => { snack.hidden = true; }, hoanTacDuoc ? 7000 : 3500);
  }

  // ================= NỐI / GỠ / THÊM / XOÁ =================
  function noi(tu: string, den: string): boolean {
    if (laNoiNguoc(tt, tu, den)) { thuTaoLap(tu, den); return false; } // ô đứng TRƯỚC cùng đường → hỏi tạo VÒNG LẶP (không thành cạnh thường khép kín)
    const k = kiemNoi(tt, tu, den, tenId);
    if (!k.ok) { thongBao(k.lyDo, "warn"); chop(tu); return false; }
    ghiLichSu();
    tt = { ...tt, canh: [...tt.canh, { tu, den }] };
    veTatCa(); phat(true, false);
    thongBao(`Đã nối “${tenId(tu)}” → “${tenId(den)}”`);
    return true;
  }
  function goNoi(c: CanhDoThi): boolean {
    const i = tt.canh.findIndex((x) => x.tu === c.tu && x.den === c.den);
    const k = kiemXoaCanh(tt, i);
    if (!k.ok) { thongBao(k.lyDo, "warn"); return false; }
    ghiLichSu();
    tt = { ...tt, canh: tt.canh.filter((_, j) => j !== i) };
    veTatCa(); phat(true, false);
    snackHienThi(`Đã gỡ nối “${tenId(c.tu)}” → “${tenId(c.den)}”`, true);
    return true;
  }
  function chop(id: string): void { const e = elNut.get(id); if (!e) return; e.el.classList.remove("chop"); void e.el.offsetWidth; e.el.classList.add("chop"); hen.push(window.setTimeout(() => e.el.classList.remove("chop"), 1700)); }

  interface NguCanhThem { sauNutId?: string; truocCanh?: CanhDoThi; viTri?: ViTri; trove?: HTMLElement }
  /** Thêm ô theo `ng`; `ma` = thao tác đã chọn trong menu (nếu có danh mục). */
  async function themOMoi(ma: string | undefined, nenTang: string | undefined, ng: NguCanhThem, cach: "them" | "nhan_ban" = "them", nguon?: string): Promise<NutDoThi | null> {
    if (dangThem || daHuy) return null;
    const kieu = ng.truocCanh || ng.sauNutId ? (ng.truocCanh || tt.canh.some((c) => c.tu === ng.sauNutId) ? "chen" : "noi_duoi") : "co_lap";
    const dry = themO(chup(), { id: "__thu__", thaoTac: "x", thamSo: {} }, { truocCanh: ng.truocCanh, sauNutId: ng.sauNutId, viTri: ng.viTri });
    if ("loi" in dry) { thongBao(dry.loi, "warn"); return null; }
    const kt = kiemThemO(tt, kieu); if (!kt.ok) { thongBao(kt.lyDo, "warn"); return null; }
    const vt = ng.viTri ?? (ng.sauNutId ? undefined : viTriGiuaKhung());
    dangThem = true; btnThem.setAttribute("aria-busy", "true");
    try {
      const yc: YeuCauThemNut = { ...(ma ? { thaoTac: ma } : {}), ...(nenTang ? { nenTang } : {}), ...(ng.sauNutId ? { sauNutId: ng.sauNutId } : {}), ...(ng.truocCanh ? { truocCanh: ng.truocCanh } : {}), viTri: vt ?? vi(ng.sauNutId ?? "") };
      const moi = await (cach === "nhan_ban" ? o.cb?.nhanBan?.(nguon!) : o.cb?.themNut?.(yc));
      if (daHuy) return null;
      if (!moi) return null;
      const r = themO(chup(), moi, { truocCanh: ng.truocCanh, sauNutId: ng.sauNutId, viTri: ng.viTri ?? (ng.sauNutId ? undefined : vt) });
      if ("loi" in r) { thongBao(r.loi, "warn"); try { o.cb?.xoaNut?.(moi.id); } catch { /* trang chủ tự lo */ } return null; }
      ghiLichSu();
      tt = { ...r.tt, lap: tt.lap };
      sel = moi.id;
      veTatCa(); phat(true, true);
      if (cheDoDanhSach) dsEl.querySelector<HTMLElement>(`[data-id="${CSS.escape(moi.id)}"] button`)?.focus({ preventScroll: true });
      else { hienRoi(moi.id); elNut.get(moi.id)?.el.focus({ preventScroll: true }); }
      thongBao(`Đã thêm ô “${tenO(moi)}”${ng.truocCanh ? " vào giữa nối" : ng.sauNutId ? " và nối tiếp" : ""}`);
      return moi;
    } catch (e) { thongBao(e instanceof Error ? e.message : "Không thêm được ô", "err"); return null; }
    finally { dangThem = false; btnThem.removeAttribute("aria-busy"); }
  }
  function viTriGiuaKhung(): ViTri { const r = vpRect(); const p = thanhToaDo(r.left + r.width / 2, r.top + r.height / 2); return { x: Math.round(p.x - W / 2), y: Math.round(p.y - H / 2) }; }

  function xoaNutNgay(id: string): void {
    if (chiDoc()) return;
    const n = tt.nut.find((x) => x.id === id); if (!n) return;
    const ten = tenO(n);
    const kế = tt.nut[tt.nut.findIndex((x) => x.id === id) + 1] ?? tt.nut[tt.nut.findIndex((x) => x.id === id) - 1];
    const soNoi = tt.canh.filter((c) => c.tu === id || c.den === id).length;
    xoaCuoi = { t: performance.now(), id: kế?.id ?? "" };
    ghiLichSu();
    const r = xoaO(tt, id);
    const lapDoi = (r.tt.lap ?? []).length !== tt.lap.length;
    tt = { ...r.tt, lap: r.tt.lap ?? [] };
    if (sel === id) sel = null;
    if (nguonNoi === id) datNguonNoi(null);
    try { o.cb?.xoaNut?.(id); } catch (e) { thongBao(e instanceof Error ? e.message : "Lỗi khi xoá ô", "err"); }
    veTatCa(); phat(true, true, lapDoi);
    snackHienThi(`Đã xoá “${ten}”${soNoi ? ` (${soNoi} nối${r.noiLai ? "; đã tự nối lại hai đầu" : ""})` : ""}`, true);
    if (kế && !cheDoDanhSach) { chon(kế.id); elNut.get(kế.id)?.el.focus({ preventScroll: true }); }
  }
  function nhanBanNgay(id: string): void { if (!chiDoc()) void themOMoi(undefined, undefined, { sauNutId: id }, "nhan_ban", id); }
  function doiNhuongNgay(id: string): void {
    if (chiDoc()) return;
    const n = tt.nut.find((x) => x.id === id); if (!n || !laNghi(n)) return;
    const moi = !nhuongHL(n);
    ghiLichSu();
    tt = { ...tt, nut: tt.nut.map((x) => (x.id === id ? { ...x, nhuong: moi } : x)) };
    try { o.cb?.doiNhuong?.(id); } catch (e) { thongBao(e instanceof Error ? e.message : "Lỗi khi đổi điểm nhường", "err"); }
    veTatCa(); thongBao(`Ô “${tenO(n)}” ${moi ? "là điểm nhường: bot làm xen đường khác trong lúc nghỉ" : "không còn là điểm nhường"}`);
  }
  function moChiTiet(id: string): void { try { o.cb?.moChiTiet?.(id); } catch (e) { thongBao(e instanceof Error ? e.message : "Lỗi khi mở chi tiết", "err"); } }

  // ================= TỰ DÀN =================
  function huyTween(chotNgay: boolean): void { if (tweenRaf) { cancelAnimationFrame(tweenRaf); tweenRaf = 0; const f = tweenXong; tweenXong = null; if (chotNgay && f) f(); } }
  function tuDanNgay(): void {
    if (chiDoc() || !tt.nut.length) return;
    huyTween(true);
    ghiLichSu();
    const dich = tuDan(tt.nut, tt.canh);
    const tu = JSON.parse(JSON.stringify(tt.boCuc)) as BoCuc;
    const xong = (): void => {
      tweenXong = null; tweenRaf = 0;
      tt = { ...tt, boCuc: dich };
      veTatCa(); phat(false, true); vuaKhungNgay();
    };
    const giam = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    if (giam) xong();
    else {
      tweenXong = xong;
      const t0 = performance.now(), ms = 380;
      const buoc = (now: number): void => {
        if (daHuy) return;
        const p = Math.min(1, (now - t0) / ms), e = 1 - Math.pow(1 - p, 3);
        const bc: BoCuc = {};
        for (const n of tt.nut) { const a = tu[n.id] ?? dich[n.id]!, b = dich[n.id]!; bc[n.id] = { x: Math.round(a.x + (b.x - a.x) * e), y: Math.round(a.y + (b.y - a.y) * e) }; }
        tt = { ...tt, boCuc: bc };
        for (const n of tt.nut) datViTriEl(n.id);
        for (const c of tt.canh) veCanh(c);
        veTatCaLap();
        capNhatNutMore(); veMini();
        if (p < 1) tweenRaf = requestAnimationFrame(buoc); else xong();
      };
      tweenRaf = requestAnimationFrame(buoc);
    }
    snackHienThi("Đã tự dàn theo thứ tự chạy: mỗi đường một hàng", true);
  }

  // ================= MENU =================
  let menuTroVe: HTMLElement | null = null;
  let menuNeo: { cx: number; cy: number } | null = null; // điểm neo của menu đang mở — đặt lại vị trí khi đổi cỡ cửa sổ
  function dongMenu(trave = true): void {
    if (menu.hidden) return;
    menu.hidden = true; menu.replaceChildren(); menu.onclick = null; menuNeo = null;
    const r = menuTroVe; menuTroVe = null;
    if (trave && r && root.contains(r)) r.focus({ preventScroll: true });
  }
  function datViTriMenu(cx: number, cy: number): void {
    menu.hidden = false;
    menuNeo = { cx, cy };
    const r = menu.getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    menu.style.left = `${Math.max(8, Math.min(cx + 6, vw - r.width - 8))}px`;
    menu.style.top = `${Math.max(8, Math.min(cy + 6, vh - r.height - 8))}px`;
  }
  // Menu là position: fixed — đổi cỡ cửa sổ (xoay màn hình, kéo cửa sổ hẹp lại) khi menu đang mở thì phải tính lại vị trí, nếu không nó tràn ra ngoài màn hình (E2E boss-so-do-ux P4, 11/10/2026).
  nghe(window, "resize", () => { if (!menu.hidden && menuNeo) datViTriMenu(menuNeo.cx, menuNeo.cy); });
  const muc = (nhan: Node | string, extra: Record<string, unknown> = {}): HTMLButtonElement => h("button", { type: "button", role: "menuitem", title: typeof nhan === "string" ? nhan : "Chọn mục này", ...extra }, nhan);
  const huyHieuNho = (ma: string): HTMLElement => { const m = maMang(ma); return h("span", { class: `sdc-b b-${m.ma}`, "aria-hidden": "true" }, m.chu || "•"); };
  const sepMenu = (): HTMLElement => h("div", { class: "sdc-sep", role: "separator" });
  const tuyChonDong = (): HTMLButtonElement => muc("Đóng (Esc)", { "data-dong": "1" });

  interface NguMenuThem { cx: number; cy: number; trove?: HTMLElement; trungTam?: boolean; nguon?: string; canh?: CanhDoThi; viTri?: ViTri }
  /** Menu "Thêm ô": chọn mạng rồi thao tác. Không có danh mục → gọi thẳng cb.themNut. */
  function moMenuThem(ng: NguMenuThem): void {
    if (chiDoc() || daHuy) return;
    if (tt.nut.length >= GIOI_HAN_DO_THI.nut) { thongBao(`Đồ thị tối đa ${GIOI_HAN_DO_THI.nut} ô (đang có ${tt.nut.length}). Hãy xoá bớt ô không cần.`, "warn"); return; }
    const ctx: NguCanhThem = { ...(ng.nguon ? { sauNutId: ng.nguon } : {}), ...(ng.canh ? { truocCanh: ng.canh } : {}), ...(ng.viTri ? { viTri: ng.viTri } : {}) };
    const dm = o.danhMuc ?? [];
    if (!o.cb?.themNut) { thongBao("Trang này chưa cho thêm ô vào sơ đồ.", "warn"); return; }
    if (!dm.length) { void themOMoi(undefined, undefined, ctx); return; }
    dongMenu(false);
    menuTroVe = ng.trove ?? null;
    const nguonNut = ng.nguon ? tt.nut.find((n) => n.id === ng.nguon) : ng.canh ? tt.nut.find((n) => n.id === ng.canh!.tu) : undefined;
    let mang = (nguonNut && nenTangCua(nguonNut)) || lastMang || dm[0]!.nenTang;
    if (!dm.some((d) => d.nenTang === mang)) mang = dm[0]!.nenTang;
    const ve = (): void => {
      const cur = dm.find((d) => d.nenTang === mang) ?? dm[0]!;
      menu.replaceChildren(
        h("h3", {}, ng.canh ? "Chèn ô vào giữa" : ng.nguon ? `Thêm ô và nối từ “${tenId(ng.nguon)}”` : "Thêm ô"),
        h("div", { class: "sdc-seg", role: "group", "aria-label": "Mạng" }, ...dm.map((d) => h("button", { type: "button", "data-mang": d.nenTang, "aria-pressed": String(d.nenTang === mang), title: `Chọn mạng ${d.ten ?? d.nenTang}` }, huyHieuNho(d.nenTang), d.ten ?? maMang(d.nenTang).ten ?? d.nenTang))),
        ...cur.thaoTac.map((t) => muc(t.ten, { "data-ma": t.ma })),
        sepMenu(), tuyChonDong());
    };
    ve();
    menu.setAttribute("aria-label", "Thêm ô");
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.mang) { mang = b.dataset.mang; lastMang = mang; ve(); menu.querySelector<HTMLElement>(`[data-mang="${CSS.escape(mang)}"]`)?.focus(); return; }
      if (b.dataset.dong) { dongMenu(); return; }
      if (b.dataset.ma) { const ma = b.dataset.ma; menuTroVe = null; dongMenu(false); void themOMoi(ma, mang, { ...ctx }); }
    };
    datViTriMenu(ng.cx, ng.cy);
    (menu.querySelector("[data-ma]") as HTMLElement | null)?.focus({ preventScroll: true });
  }
  let lastMang: string | undefined;

  /** Menu của một nối: chèn ô vào giữa (cùng menu Thêm ô) + gỡ nối. */
  function moMenuCanh(c: CanhDoThi, cx: number, cy: number, trove?: HTMLElement): void {
    if (chiDoc()) return;
    dongMenu(false);
    menuTroVe = trove ?? null;
    const dm = o.danhMuc ?? [];
    const nguonNut = tt.nut.find((n) => n.id === c.tu);
    let mang = (nguonNut && nenTangCua(nguonNut)) || lastMang || dm[0]?.nenTang || "";
    if (dm.length && !dm.some((d) => d.nenTang === mang)) mang = dm[0]!.nenTang;
    const ve = (): void => {
      const cur = dm.find((d) => d.nenTang === mang);
      menu.replaceChildren(
        h("h3", {}, `Nối: ${tenId(c.tu)} → ${tenId(c.den)}`),
        ...(dm.length
          ? [h("div", { class: "sdc-seg", role: "group", "aria-label": "Mạng của ô chèn" }, ...dm.map((d) => h("button", { type: "button", "data-mang": d.nenTang, "aria-pressed": String(d.nenTang === mang), title: `Chọn mạng ${d.ten ?? d.nenTang}` }, huyHieuNho(d.nenTang), d.ten ?? maMang(d.nenTang).ten ?? d.nenTang))),
             ...(cur?.thaoTac ?? []).map((t) => muc(`Chèn: ${t.ten}`, { "data-ma": t.ma }))]
          : [muc("Chèn ô vào giữa", { "data-chen": "1" })]),
        sepMenu(), muc("Gỡ nối này", { class: "sdc-nguy", "data-go": "1" }), tuyChonDong());
    };
    ve();
    menu.setAttribute("aria-label", "Sửa nối");
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.mang) { mang = b.dataset.mang; lastMang = mang; ve(); menu.querySelector<HTMLElement>(`[data-mang="${CSS.escape(mang)}"]`)?.focus(); return; }
      if (b.dataset.dong) { dongMenu(); return; }
      if (b.dataset.go) { menuTroVe = null; dongMenu(false); goNoi(c); return; }
      if (b.dataset.chen) { menuTroVe = null; dongMenu(false); void themOMoi(undefined, undefined, { truocCanh: c }); return; }
      if (b.dataset.ma) { const ma = b.dataset.ma; menuTroVe = null; dongMenu(false); void themOMoi(ma, mang || undefined, { truocCanh: c }); }
    };
    datViTriMenu(cx, cy);
    (menu.querySelector("[data-ma],[data-chen]") as HTMLElement | null)?.focus({ preventScroll: true });
  }

  /** "Nối tới…": chọn ô đích bằng bàn phím / danh sách; ô không nối được vẫn hiện, kèm lý do. */
  function moMenuNoiToi(nguon: string, trove?: HTMLElement): void {
    if (chiDoc()) return;
    dongMenu(false);
    menuTroVe = trove ?? elNut.get(nguon)?.el ?? null;
    const ung = thuTuDoc(tt.nut, tt.canh).map((x) => x.nut).filter((n) => n.id !== nguon);
    menu.setAttribute("aria-label", "Nối tới…");
    menu.replaceChildren(
      h("h3", {}, `Nối tới… (từ “${tenId(nguon)}”)`),
      ...(ung.length ? ung.map((n) => {
        if (laNoiNguoc(tt, nguon, n.id)) {
          const kl = kiemLap(tt, nguon, n.id, tenId);
          return h("button", { type: "button", role: "menuitem", "data-lap-den": n.id, "aria-disabled": kl.ok ? "false" : "true", class: kl.ok ? "sdc-md-lap" : "sdc-khong", title: kl.ok ? `Tạo vòng lặp: sau “${tenId(nguon)}” quay lại “${tenO(n)}”` : kl.lyDo },
            huyHieuNho(nenTangCua(n) ?? ""), h("span", { class: "sdc-md-chu" }, `↺ Quay lại «${tenO(n)}» (tạo vòng lặp)`, kl.ok ? null : h("small", {}, kl.lyDo)));
        }
        const k = kiemNoi(tt, nguon, n.id, tenId);
        return h("button", { type: "button", role: "menuitem", "data-den": n.id, "aria-disabled": k.ok ? "false" : "true", class: k.ok ? "" : "sdc-khong", title: k.ok ? `Nối tới “${tenO(n)}”` : k.lyDo },
          huyHieuNho(nenTangCua(n) ?? ""), h("span", { class: "sdc-md-chu" }, tenO(n), k.ok ? null : h("small", {}, k.lyDo)));
      }) : [h("p", { class: "sdc-trong" }, "Chưa có ô nào khác.")]),
      sepMenu(), tuyChonDong());
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.dong) { dongMenu(); return; }
      if (b.dataset.lapDen) { const den = b.dataset.lapDen; const kl = kiemLap(tt, nguon, den, tenId); if (!kl.ok) { thongBao(kl.lyDo, "warn"); return; } menuTroVe = null; moHopLap(nguon, den); return; }
      if (b.dataset.den) {
        const den = b.dataset.den;
        const k = kiemNoi(tt, nguon, den, tenId);
        if (!k.ok) { thongBao(k.lyDo, "warn"); return; } // giữ menu để chọn ô khác
        const tv = menuTroVe; menuTroVe = null; dongMenu(false);
        noi(nguon, den);
        if (tv && root.contains(tv)) tv.focus({ preventScroll: true });
      }
    };
    const r = (menuTroVe ?? vp).getBoundingClientRect();
    datViTriMenu(r.left + 10, r.bottom);
    (menu.querySelector("[data-den]") as HTMLElement | null ?? menu.querySelector("button"))?.focus({ preventScroll: true });
  }

  /** Menu thao tác của ô (chuột phải / phím M / nút ⋯). */
  function moMenuO(id: string, cx: number, cy: number, trove?: HTMLElement): void {
    const n = tt.nut.find((x) => x.id === id); if (!n) return;
    dongMenu(false);
    menuTroVe = trove ?? elNut.get(id)?.el ?? null;
    const sua = !chiDoc();
    const coRa = tt.canh.find((c) => c.tu === id), coVao = tt.canh.find((c) => c.den === id);
    menu.setAttribute("aria-label", `Thao tác với “${tenO(n)}”`);
    menu.replaceChildren(
      h("h3", {}, tenO(n)),
      muc(sua ? "Mở chi tiết…" : "Xem chi tiết…", { "data-a": "ct" }),
      ...(sua ? [
        muc("Nối tới…", { "data-a": "noi" }),
        muc("Chèn ô sau", { "data-a": "sau" }),
        muc("Nhân bản", { "data-a": "nb" }),
        ...(laNghi(n) ? [muc(nhuongHL(n) ? "Tắt điểm nhường" : "Bật điểm nhường", { "data-a": "nhuong", "aria-pressed": String(nhuongHL(n)) }), muc("Dành cho nhánh…", { "data-a": "danh", "data-testid": "sdc-menu-danh-cho" })] : [muc("Tần suất…", { "data-a": "ts", "data-testid": "sdc-menu-tan-suat" })]),
        ...(coRa ? [muc(`Gỡ nối tới “${tenId(coRa.den)}”`, { "data-a": "go-ra" })] : []),
        ...(coVao ? [muc(`Gỡ nối từ “${tenId(coVao.tu)}”`, { "data-a": "go-vao" })] : []),
        sepMenu(), muc("Xoá ô", { class: "sdc-nguy", "data-a": "xoa" }),
      ] : []),
      tuyChonDong());
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.dong) { dongMenu(); return; }
      const a = b.dataset.a; if (!a) return;
      const tv = menuTroVe;
      if (a === "noi") { moMenuNoiToi(id, tv ?? undefined); return; }
      menuTroVe = null; dongMenu(false);
      if (a === "ct") moChiTiet(id);
      else if (a === "sau") { const r = (tv ?? elNut.get(id)?.el)?.getBoundingClientRect(); moMenuThem({ cx: r?.left ?? 0, cy: r?.bottom ?? 0, nguon: id, ...(tv ? { trove: tv } : {}) }); }
      else if (a === "nb") nhanBanNgay(id);
      else if (a === "nhuong") doiNhuongNgay(id);
      else if (a === "danh") moHopDanhCho(id, tv ?? undefined);
      else if (a === "ts") moHopTanSuat(id, tv ?? undefined);
      else if (a === "go-ra" && coRa) goNoi(coRa);
      else if (a === "go-vao" && coVao) goNoi(coVao);
      else if (a === "xoa") xoaNutNgay(id);
    };
    datViTriMenu(cx, cy);
    (menu.querySelector("[data-a]") as HTMLElement | null)?.focus({ preventScroll: true });
  }
  nghe(menu, "keydown", (e: KeyboardEvent) => {
    if (e.key === "Escape") { e.preventDefault(); e.stopPropagation(); dongMenu(); return; }
    const t = e.target as HTMLElement;
    if (t.tagName === "INPUT") {
      if (e.key === "Enter" && !e.isComposing) { e.preventDefault(); menu.querySelector<HTMLButtonElement>("[data-chinh]")?.click(); }
      return; // mũi tên trong ô số / giờ đổi giá trị, không nhảy mục
    }
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      const bs = [...menu.querySelectorAll<HTMLElement>("button")];
      const i = bs.indexOf(document.activeElement as HTMLElement);
      if (!bs.length) return;
      e.preventDefault();
      bs[(i + (e.key === "ArrowDown" ? 1 : -1) + bs.length) % bs.length]!.focus();
    }
  });
  nghe(document, "pointerdown", (e: PointerEvent) => {
    if (menu.hidden) return;
    const t = e.target as Node;
    if (menu.contains(t)) return;
    if ((t as HTMLElement).closest?.(".sdc-canh-them, .sdc-more, .sdc-lap-nhan, .sdc-lap-ca")) return;
    dongMenu(false);
  }, true);

  // ================= VÒNG LẶP: hộp tạo / sửa / gỡ =================
  /** Kéo ngược (hoặc "Nối tới…") về ô đứng trước: kiểm luật (đường khác / cắt chéo / đã có vòng → toast lý do), hợp lệ thì mở hộp tạo vòng. */
  function thuTaoLap(tu: string, den: string): void {
    if (chiDoc()) return;
    const k = kiemLap(tt, tu, den, tenId);
    if (!k.ok) { thongBao(k.lyDo, "warn"); chop(tu); return; }
    moHopLap(tu, den);
  }
  /** Thân vòng (các ô từ `den` tới `tu` trên cùng đường) có ô Nghỉ không. */
  function coNghiTrongVong(tu: string, den: string): boolean {
    for (const ds of tachDuong(tt.nut, tt.canh)) {
      const a = ds.findIndex((n) => n.id === den), b = ds.findIndex((n) => n.id === tu);
      if (a >= 0 && b >= a) return ds.slice(a, b + 1).some(laNghi);
    }
    return false;
  }
  function moHopLap(tu: string, den: string, trove?: HTMLElement): void {
    if (chiDoc() || daHuy) return;
    const cu = tt.lap.find((c) => c.tu === tu && c.den === den);
    dongMenu(false);
    menuTroVe = trove ?? elNut.get(tu)?.el ?? null;
    menu.setAttribute("aria-label", cu ? "Sửa vòng lặp" : "Tạo vòng lặp");
    const so = h("input", { type: "text", inputmode: "numeric", autocomplete: "off", value: String(cu?.soLan ?? 2), "data-testid": "sdc-lap-so", "aria-describedby": `sdc-lap-goi-y-${uid}` }) as HTMLInputElement;
    const coGio = h("input", { type: "checkbox", "data-testid": "sdc-lap-co-gio", checked: !!cu?.denGio }) as HTMLInputElement;
    const gio = h("input", { type: "time", value: cu?.denGio ?? "", "data-testid": "sdc-lap-gio", disabled: !cu?.denGio, "aria-label": "Lặp tới giờ (giờ Việt Nam)" }) as HTMLInputElement;
    const canhBaoEl = h("p", { class: "sdc-lap-cb", role: "status", "data-testid": "sdc-lap-canh-bao" });
    const loiEl = h("p", { class: "sdc-lap-loi", role: "alert", "data-testid": "sdc-lap-loi" });
    // (đợt A) "lặp tới khi hết bước Nghỉ": nhánh được một bước Nghỉ gán chạy vòng này tới khi hết bước Nghỉ (bỏ qua số lần)
    const coHet = h("input", { type: "checkbox", "data-testid": "sdc-lap-het-nghi", checked: !!cu?.denHetNghi }) as HTMLInputElement;
    so.disabled = coHet.checked;
    coHet.addEventListener("change", () => { so.disabled = coHet.checked; });
    const nghiCo = coNghiTrongVong(tu, den);
    const veCanhBao = (): void => {
      const v = docSoLan(so.value);
      canhBaoEl.textContent = v.ok && v.so > 3 && !nghiCo ? "⚠ Vòng này không qua ô Nghỉ nào — lặp liền không nghỉ dễ bị mạng xã hội hạn chế (vẫn tạo được; nên thêm ô Nghỉ trong vòng)." : "";
      canhBaoEl.hidden = !canhBaoEl.textContent;
    };
    so.addEventListener("input", veCanhBao);
    coGio.addEventListener("change", () => { gio.disabled = !coGio.checked; if (coGio.checked) gio.focus(); });
    const ok = h("button", { type: "button", class: "sdc-btn-chinh", "data-chinh": "1", "data-testid": "sdc-lap-ok", title: cu ? "Lưu số lần / giờ của vòng lặp" : "Tạo vòng lặp quay lại ô này" }, cu ? "Lưu" : "Tạo vòng");
    const go = cu ? h("button", { type: "button", class: "sdc-nguy", "data-testid": "sdc-lap-go", title: "Gỡ vòng lặp này (các ô vẫn giữ nguyên, có Hoàn tác)" }, "Gỡ vòng") : null;
    const huy = h("button", { type: "button", "data-testid": "sdc-lap-huy", "data-dong": "1", title: "Đóng, không đổi gì (Esc)" }, "Huỷ");
    menu.replaceChildren(
      h("h3", {}, cu ? `Vòng lặp quay lại «${tenId(den)}»` : `Tạo vòng lặp quay lại «${tenId(den)}»?`),
      h("p", { class: "sdc-lap-mo-ta", id: `sdc-lap-goi-y-${uid}` }, `Xong ô “${tenId(tu)}” thì bot quay lại ô “${tenId(den)}” làm tiếp. Không bao giờ lặp mãi: tối đa 20 lần.`),
      h("label", { class: "sdc-lap-dong" }, h("span", {}, "Làm thêm (lần)"), so),
      h("label", { class: "sdc-lap-dong sdc-lap-gio" }, coGio, h("span", {}, "Lặp tới giờ (giờ VN) — tới giờ thì thoát vòng, làm tiếp ô sau"), gio),
      h("label", { class: "sdc-lap-dong sdc-lap-het", title: "Chỉ dùng cho nhánh đã được một bước Nghỉ “dành cho”: vòng lặp tới khi bước Nghỉ đó hết; không bắt đầu vòng mới nếu không kịp" }, coHet, h("span", {}, "Lặp tới khi hết bước Nghỉ đã gán (bỏ qua số lần)")),
      canhBaoEl, loiEl,
      h("div", { class: "sdc-lap-nut" }, ok, ...(go ? [go] : []), huy));
    veCanhBao(); loiEl.hidden = true;
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.dong) { dongMenu(); return; }
      if (b === go) {
        ghiLichSu();
        tt = { ...tt, lap: tt.lap.filter((c) => !(c.tu === tu && c.den === den)) };
        menuTroVe = null; dongMenu(false);
        veTatCa(); phat(false, false, true);
        snackHienThi(`Đã gỡ vòng lặp “${tenId(tu)}” → “${tenId(den)}”`, true);
        return;
      }
      if (b !== ok) return;
      const v = coHet.checked ? ({ ok: true, so: cu?.soLan ?? 2 } as const) : docSoLan(so.value);
      if (!v.ok) { loiEl.textContent = v.lyDo; loiEl.hidden = false; so.focus(); return; }
      const g = coGio.checked ? gio.value.trim() : "";
      if (coGio.checked && !/^([01]\d|2[0-3]):[0-5]\d$/.test(g)) { loiEl.textContent = "Chọn giờ (HH:MM) hoặc bỏ dấu “Lặp tới giờ”"; loiEl.hidden = false; gio.focus(); return; }
      const moi: CanhLap = { tu, den, kieu: "lap", soLan: v.so, ...(g ? { denGio: g } : {}), ...(coHet.checked ? { denHetNghi: true } : {}) };
      if (cu && JSON.stringify(cu) === JSON.stringify(moi)) { dongMenu(); return; }
      const thu = { nut: tt.nut, canh: tt.canh, lap: tt.lap.filter((c) => c !== cu) };
      const k = kiemLap(thu, tu, den, tenId);
      if (!k.ok) { loiEl.textContent = k.lyDo; loiEl.hidden = false; return; }
      ghiLichSu();
      tt = { ...tt, lap: cu ? tt.lap.map((c) => (c === cu ? moi : c)) : [...tt.lap, moi] };
      menuTroVe = null; dongMenu(false);
      veTatCa(); phat(false, false, true);
      thongBao(`${cu ? "Đã sửa" : "Đã tạo"} vòng lặp: sau “${tenId(tu)}” quay lại “${tenId(den)}” ${nhanLap(moi)}`);
      (trove && root.contains(trove) ? trove : elNut.get(tu)?.el)?.focus({ preventScroll: true });
    };
    const r = (menuTroVe ?? vp).getBoundingClientRect();
    datViTriMenu(r.left + 10, r.bottom);
    so.focus({ preventScroll: true }); so.select();
  }
  // ================= (đợt A) BƯỚC NGHỈ "DÀNH CHO" + TẦN SUẤT =================
  /** Hộp "Dành cho": chọn nhánh sẽ chạy trong lúc bước Nghỉ này nghỉ ((không) = như cũ: nhánh nào sẵn sàng thì chen). */
  function moHopDanhCho(id: string, trove?: HTMLElement): void {
    if (chiDoc() || daHuy) return;
    const n = tt.nut.find((x) => x.id === id); if (!n || !laNghi(n)) return;
    dongMenu(false);
    menuTroVe = trove ?? elNut.get(id)?.el ?? null;
    menu.setAttribute("aria-label", "Bước Nghỉ dành cho nhánh");
    const ds = cacNhanhKhac(tt.nut, tt.canh, id);
    const chon = h("select", { "data-testid": "sdc-danh-cho-chon", "aria-label": "Nhánh được chạy trong lúc bước Nghỉ này nghỉ" },
      h("option", { value: "" }, "(không) — nhánh nào sẵn sàng thì chen vào"),
      ...ds.map((d) => h("option", { value: d.id }, `Nhánh ${tenNhanhCua(d.id)} — bắt đầu ở “${tenO(d.nut[0]!)}” (${d.nut.length} bước)`))) as HTMLSelectElement;
    const hienTai = n.danhCho ? (ds.find((d) => d.nut.some((x) => x.id === n.danhCho))?.id ?? "") : "";
    chon.value = hienTai;
    const ok = h("button", { type: "button", class: "sdc-btn-chinh", "data-chinh": "1", "data-testid": "sdc-danh-cho-ok", title: "Lưu nhánh được chạy trong lúc bước Nghỉ này nghỉ" }, "Lưu");
    const huy = h("button", { type: "button", "data-dong": "1", "data-testid": "sdc-danh-cho-huy", title: "Đóng, không đổi gì (Esc)" }, "Huỷ");
    menu.replaceChildren(
      h("h3", {}, `Bước Nghỉ “${tenO(n)}” dành cho nhánh…`),
      h("p", { class: "sdc-lap-mo-ta" }, ds.length
        ? "Trong lúc bước Nghỉ này nghỉ, CHỈ nhánh được chọn được chạy (nhánh đó chỉ chạy trong các bước Nghỉ dành cho nó; muốn nó lặp tới khi hết nghỉ thì tạo vòng lặp “tới khi hết bước Nghỉ” trên nhánh đó). Bước Nghỉ được gán luôn tách đoạn để bot rảnh thật, dài tới 6 giờ."
        : "Sơ đồ chưa có nhánh nào khác — thêm một nhánh (vd TikTok) rồi gán."),
      h("label", { class: "sdc-lap-dong" }, h("span", {}, "Dành cho"), chon),
      h("div", { class: "sdc-lap-nut" }, ok, huy));
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.dong) { dongMenu(); return; }
      if (b !== ok) return;
      const v = chon.value || null;
      menuTroVe = null; dongMenu(false);
      if ((n.danhCho ?? null) === v || (v && hienTai === v)) return;
      ghiLichSu();
      tt = { ...tt, nut: tt.nut.map((x) => { if (x.id !== id) return x; const { danhCho: _b, ...con } = x; void _b; return v ? { ...con, danhCho: v } : con; }) };
      try { o.cb?.datDanhCho?.(id, v); } catch (er) { thongBao(er instanceof Error ? er.message : "Lỗi khi gán bước Nghỉ", "err"); }
      veTatCa();
      thongBao(v ? `Bước Nghỉ “${tenO(n)}” dành cho nhánh ${tenNhanhCua(v)}` : `Bước Nghỉ “${tenO(n)}” không dành riêng cho nhánh nào`);
    };
    const r = (menuTroVe ?? vp).getBoundingClientRect();
    datViTriMenu(r.left + 10, r.bottom);
    chon.focus({ preventScroll: true });
  }
  /** Hộp "Tần suất" của bước việc: mỗi lần (mặc định) / chỉ lần đầu mỗi ngày / cứ N ngày một lần (2–60). */
  function moHopTanSuat(id: string, trove?: HTMLElement): void {
    if (chiDoc() || daHuy) return;
    const n = tt.nut.find((x) => x.id === id); if (!n || laNghi(n)) return;
    dongMenu(false);
    menuTroVe = trove ?? elNut.get(id)?.el ?? null;
    menu.setAttribute("aria-label", "Tần suất của bước");
    const kieu = h("select", { "data-testid": "sdc-tan-suat-kieu", "aria-label": "Tần suất" },
      h("option", { value: "" }, "Mỗi lần chạy (mặc định)"), h("option", { value: "dau_ngay" }, "Chỉ lần đầu mỗi ngày"), h("option", { value: "n_ngay" }, "Cứ N ngày một lần")) as HTMLSelectElement;
    kieu.value = n.tanSuat?.kieu ?? "";
    const soN = h("input", { type: "text", inputmode: "numeric", autocomplete: "off", value: n.tanSuat?.kieu === "n_ngay" ? String(n.tanSuat.n) : "2", "data-testid": "sdc-tan-suat-n", "aria-label": "Số ngày N (2–60)" }) as HTMLInputElement;
    const dongN = h("label", { class: "sdc-lap-dong" }, h("span", {}, "N (ngày, 2–60)"), soN);
    const loiEl = h("p", { class: "sdc-lap-loi", role: "alert", "data-testid": "sdc-tan-suat-loi", hidden: true });
    const veN = (): void => { dongN.hidden = kieu.value !== "n_ngay"; };
    kieu.addEventListener("change", veN); veN();
    const ok = h("button", { type: "button", class: "sdc-btn-chinh", "data-chinh": "1", "data-testid": "sdc-tan-suat-ok", title: "Lưu tần suất của bước này" }, "Lưu");
    const huy = h("button", { type: "button", "data-dong": "1", title: "Đóng, không đổi gì (Esc)" }, "Huỷ");
    menu.replaceChildren(
      h("h3", {}, `Tần suất của bước “${tenO(n)}”`),
      h("p", { class: "sdc-lap-mo-ta" }, "Tính theo từng bot, ngày giờ Việt Nam. Chưa tới hạn thì bot BỎ QUA bước này (không phải lỗi). Bước có tần suất riêng được tách thành đoạn riêng."),
      h("label", { class: "sdc-lap-dong" }, h("span", {}, "Chạy"), kieu), dongN, loiEl,
      h("div", { class: "sdc-lap-nut" }, ok, huy));
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.dong) { dongMenu(); return; }
      if (b !== ok) return;
      let ts: NutDoThi["tanSuat"] | null = null;
      if (kieu.value === "dau_ngay") ts = { kieu: "dau_ngay" };
      else if (kieu.value === "n_ngay") {
        const t = soN.value.trim();
        if (!/^\d+$/.test(t) || Number(t) < 2 || Number(t) > 60) { loiEl.textContent = "N phải là số nguyên từ 2 đến 60"; loiEl.hidden = false; soN.focus(); return; }
        ts = { kieu: "n_ngay", n: Number(t) };
      }
      menuTroVe = null; dongMenu(false);
      if (JSON.stringify(n.tanSuat ?? null) === JSON.stringify(ts)) return;
      ghiLichSu();
      tt = { ...tt, nut: tt.nut.map((x) => { if (x.id !== id) return x; const { tanSuat: _b, ...con } = x; void _b; return ts ? { ...con, tanSuat: ts } : con; }) };
      try { o.cb?.datTanSuat?.(id, ts); } catch (er) { thongBao(er instanceof Error ? er.message : "Lỗi khi đặt tần suất", "err"); }
      veTatCa();
      thongBao(ts ? `Bước “${tenO(n)}”: ${chuTanSuat(ts)}` : `Bước “${tenO(n)}” chạy mỗi lần`);
    };
    const r = (menuTroVe ?? vp).getBoundingClientRect();
    datViTriMenu(r.left + 10, r.bottom);
    kieu.focus({ preventScroll: true });
  }
  /** Hộp "Lặp cả sơ đồ": số vòng 1..20, nghỉ giữa vòng (phút, từ–đến); Bỏ = không lặp. */
  function moHopLapCa(): void {
    if (chiDoc() || daHuy) return;
    dongMenu(false);
    menuTroVe = btnLapCa;
    menu.setAttribute("aria-label", "Lặp cả sơ đồ");
    const so = h("input", { type: "text", inputmode: "numeric", autocomplete: "off", value: String(lapCa?.soVong ?? 2), "data-testid": "sdc-lapca-so", "aria-label": "Số vòng" }) as HTMLInputElement;
    const tu = h("input", { type: "text", inputmode: "numeric", autocomplete: "off", value: String(lapCa ? Math.round(lapCa.nghiGiuaVongTuS / 60) : 30), "data-testid": "sdc-lapca-tu", "aria-label": "Nghỉ giữa vòng từ (phút)" }) as HTMLInputElement;
    const den = h("input", { type: "text", inputmode: "numeric", autocomplete: "off", value: String(lapCa ? Math.round(lapCa.nghiGiuaVongDenS / 60) : 60), "data-testid": "sdc-lapca-den", "aria-label": "Nghỉ giữa vòng đến (phút)" }) as HTMLInputElement;
    const loiEl = h("p", { class: "sdc-lap-loi", role: "alert", "data-testid": "sdc-lapca-loi", hidden: true });
    // (đợt A) "tới giờ": không bắt đầu vòng mới từ giờ này (giờ VN)
    const gio = h("input", { type: "text", inputmode: "numeric", autocomplete: "off", placeholder: "vd 23:00", value: lapCa?.denGio ?? "", "data-testid": "sdc-lapca-gio", "aria-label": "Không bắt đầu vòng mới từ giờ (HH:MM, giờ VN; bỏ trống = theo số vòng)" }) as HTMLInputElement;
    const ok = h("button", { type: "button", class: "sdc-btn-chinh", "data-chinh": "1", "data-testid": "sdc-lapca-ok", title: "Lưu số vòng và nghỉ giữa vòng" }, "Lưu");
    const bo = lapCa ? h("button", { type: "button", class: "sdc-nguy", "data-testid": "sdc-lapca-bo", title: "Bỏ lặp: cả sơ đồ chỉ chạy một vòng" }, "Bỏ lặp cả sơ đồ") : null;
    menu.replaceChildren(
      h("h3", {}, "Lặp cả sơ đồ"),
      h("p", { class: "sdc-lap-mo-ta" }, "Mọi đường xong một vòng → bot nghỉ giữa vòng (rảnh thật) → chạy lại cả sơ đồ từ đầu. Tối đa 20 vòng."),
      h("label", { class: "sdc-lap-dong" }, h("span", {}, "Số vòng"), so),
      h("div", { class: "sdc-lap-dong" }, h("span", {}, "Nghỉ giữa vòng (phút)"), tu, h("span", { "aria-hidden": "true" }, "–"), den),
      h("label", { class: "sdc-lap-dong" }, h("span", {}, "Lặp tới giờ (không bắt đầu vòng mới từ giờ này)"), gio),
      loiEl,
      h("div", { class: "sdc-lap-nut" }, ok, ...(bo ? [bo] : []), h("button", { type: "button", "data-dong": "1", "data-testid": "sdc-lapca-huy", title: "Đóng, không đổi gì (Esc)" }, "Huỷ")));
    const ghi = (moi: LapCaSoDo | null): void => {
      lapCa = moi;
      menuTroVe = null; dongMenu(false);
      try { o.cb?.thayDoiLapCaSoDo?.(moi ? { ...moi } : null); } catch (e) { thongBao(e instanceof Error ? e.message : "Lỗi khi lưu lặp cả sơ đồ", "err"); }
      veDem();
      thongBao(moi ? `Đã đặt: ${chuLapCaSoDo(moi)}` : "Đã bỏ lặp cả sơ đồ");
      btnLapCa.focus({ preventScroll: true });
    };
    menu.onclick = (e: MouseEvent) => {
      const b = (e.target as HTMLElement).closest("button"); if (!b) return;
      if (b.dataset.dong) { dongMenu(); return; }
      if (b === bo) { ghi(null); return; }
      if (b !== ok) return;
      const v = (x: string): number => (/^\s*\d+\s*$/.test(x) ? Number(x) : NaN);
      const n = v(so.value), a = v(tu.value), z = v(den.value);
      const bao = (s2: string, el: HTMLInputElement): void => { loiEl.textContent = s2; loiEl.hidden = false; el.focus(); };
      if (!(n >= 1 && n <= 20)) { bao("Số vòng phải là số nguyên từ 1 đến 20", so); return; }
      if (!(a >= 0 && a <= 360)) { bao("Nghỉ giữa vòng phải là số phút 0–360 (tối đa 6 giờ)", tu); return; }
      if (!(z >= 0 && z <= 360)) { bao("Nghỉ giữa vòng phải là số phút 0–360 (tối đa 6 giờ)", den); return; }
      if (a > z) { bao("Nghỉ “từ” không được lớn hơn “đến”", tu); return; }
      const g = gio.value.trim();
      if (g && !/^([01]\d|2[0-3]):[0-5]\d$/.test(g)) { bao("Lặp tới giờ phải có dạng HH:MM (00:00–23:59) hoặc bỏ trống", gio); return; }
      ghi({ soVong: n, nghiGiuaVongTuS: a * 60, nghiGiuaVongDenS: z * 60, ...(g ? { denGio: g } : {}) });
    };
    const r = btnLapCa.getBoundingClientRect();
    datViTriMenu(r.left, r.bottom);
    so.focus({ preventScroll: true }); so.select();
  }

  // ================= NỐI BẰNG CHẠM NGUỒN → ĐÍCH =================
  function datNguonNoi(id: string | null): void {
    nguonNoi = id;
    root.classList.toggle("dang-noi", !!id);
    banner.hidden = !id;
    if (id) { bannerTxt.textContent = `Đang nối từ “${tenId(id)}”: chạm vào ô đích (Esc để huỷ)`; live.textContent = `Đã chọn nguồn ${tenId(id)}. Chạm ô đích.`; }
    veLopTatCa();
  }

  // ================= CON TRỎ: kéo nền / ô / cổng / chụm / bấm đúp =================
  const ptrs = new Map<number, { x: number; y: number }>();
  type Che = "pan" | "node" | "link" | "pinch" | null;
  let che: Che = null;
  interface Keo { pid: number; sx: number; sy: number; moved: boolean; id?: string; ox?: number; oy?: number; tx0?: number; ty0?: number; tu?: string; truoc?: TrangThai }
  let keo: Keo | null = null;
  let chum: { d: number; cx: number; cy: number; v: View } | null = null;
  let chamCuoi = { id: "", t: 0 };
  const kc = (a: { x: number; y: number }, b: { x: number; y: number }): number => Math.hypot(a.x - b.x, a.y - b.y);
  function huyCuChi(): void {
    if (che === "node" && keo?.moved && keo.truoc && keo.id) { tt = { ...tt, boCuc: { ...tt.boCuc, [keo.id]: { x: keo.ox!, y: keo.oy! } } }; datViTriEl(keo.id); veCanhCuaO(keo.id); }
    che = null; keo = null; chum = null; keoId = null; dgTam.setAttribute("d", ""); vp.classList.remove("panning");
    root.querySelectorAll(".drop-ok").forEach((x) => x.classList.remove("drop-ok"));
    veLopTatCa();
  }
  nghe(vp, "pointerdown", (e: PointerEvent) => {
    if ((e.target as HTMLElement).closest("button, .sdc-hit")) return;
    if (e.pointerType === "mouse" && e.button !== 0) return;
    // (vòng lặp) ô nhập trong hộp đang mở nằm ngoài khung — không ảnh hưởng
    dongMenu(false); an();
    ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (ptrs.size === 2) {
      huyCuChi();
      const [a, b] = [...ptrs.values()] as [{ x: number; y: number }, { x: number; y: number }];
      chum = { d: kc(a, b), cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2, v: { ...view } }; che = "pinch";
      return;
    }
    if (ptrs.size > 2) return;
    try { vp.setPointerCapture(e.pointerId); } catch { /* không bắt buộc */ }
    const cong = (e.target as HTMLElement).closest<HTMLElement>(".sdc-cong-ra"), nutEl = (e.target as HTMLElement).closest<HTMLElement>(".sdc-o");
    const base = { pid: e.pointerId, sx: e.clientX, sy: e.clientY, moved: false };
    if (cong && nutEl && !chiDoc()) { che = "link"; keo = { ...base, tu: nutEl.dataset.id! }; }
    else if (nutEl) {
      const id = nutEl.dataset.id!, p = vi(id);
      che = "node"; keo = { ...base, id, ox: p.x, oy: p.y };
      chon(id); nutEl.focus({ preventScroll: true });
    } else { che = "pan"; keo = { ...base, tx0: view.tx, ty0: view.ty }; vp.focus({ preventScroll: true }); }
  });
  nghe(vp, "pointermove", (e: PointerEvent) => {
    if (!ptrs.has(e.pointerId)) return;
    ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (che === "pinch" && chum && ptrs.size >= 2) {
      const [a, b] = [...ptrs.values()] as [{ x: number; y: number }, { x: number; y: number }];
      const r = vpRect();
      datView(zoomChum(chum.v, { d: chum.d, cx: chum.cx, cy: chum.cy }, { d: kc(a, b), cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 }, r.left, r.top));
      return;
    }
    if (!keo || e.pointerId !== keo.pid) return;
    const dx = e.clientX - keo.sx, dy = e.clientY - keo.sy;
    if (!keo.moved && Math.hypot(dx, dy) > (che === "link" ? 6 : 4)) {
      keo.moved = true;
      if (che === "node" && !chiDoc()) { keo.truoc = JSON.parse(JSON.stringify(chup())) as TrangThai; keoId = keo.id!; an(); const el = elNut.get(keo.id!); if (el) el.el.className = lopO(keo.id!); }
      if (che === "pan") vp.classList.add("panning");
    }
    if (!keo.moved) return;
    if (che === "pan") datView({ k: view.k, tx: keo.tx0! + dx, ty: keo.ty0! + dy });
    else if (che === "node") {
      if (chiDoc() || !keo.truoc) return;
      const id = keo.id!;
      tt = { ...tt, boCuc: { ...tt.boCuc, [id]: { x: Math.round(keo.ox! + dx / view.k), y: Math.round(keo.oy! + dy / view.k) } } };
      datViTriEl(id); veCanhCuaO(id); capNhatNutMore(); veMini();
    } else if (che === "link") {
      const w = thanhToaDo(e.clientX, e.clientY);
      dgTam.setAttribute("d", hinhHocTam(vi(keo.tu!), w.x, w.y));
      root.querySelectorAll(".drop-ok").forEach((x) => x.classList.remove("drop-ok"));
      const ne = (document.elementFromPoint(e.clientX, e.clientY) as HTMLElement | null)?.closest<HTMLElement>(".sdc-o");
      if (ne && ne.dataset.id !== keo.tu) ne.classList.add("drop-ok");
    }
  });
  function ketThucCon(e: PointerEvent, huy: boolean): void {
    const co = ptrs.delete(e.pointerId);
    if (che === "pinch") { if (ptrs.size < 2) { che = null; chum = null; } return; }
    if (!co || !keo || e.pointerId !== keo.pid) return;
    const k = keo, m = che;
    if (huy) { huyCuChi(); return; }
    che = null; keo = null; keoId = null; dgTam.setAttribute("d", ""); vp.classList.remove("panning");
    root.querySelectorAll(".drop-ok").forEach((x) => x.classList.remove("drop-ok"));
    if (m === "pan") { if (!k.moved) { if (nguonNoi) datNguonNoi(null); dongMenu(false); chon(null); } veLopTatCa(); return; }
    if (m === "node") {
      if (k.moved && k.truoc && k.id) {
        ls.ghi(k.truoc); veNutLenh();
        veLopTatCa(); phat(false, true);
        return;
      }
      veLopTatCa();
      const id = k.id!;
      if (nguonNoi && nguonNoi !== id) { const tu = nguonNoi; datNguonNoi(null); noi(tu, id); return; }
      if (nguonNoi === id) { datNguonNoi(null); return; }
      const now = performance.now();
      if (chamCuoi.id === id && now - chamCuoi.t < 420) { chamCuoi = { id: "", t: 0 }; moChiTiet(id); } else chamCuoi = { id, t: now };
      return;
    }
    if (m === "link") {
      veLopTatCa();
      const tu = k.tu!;
      if (!k.moved) { datNguonNoi(nguonNoi === tu ? null : tu); return; }
      const t = document.elementFromPoint(e.clientX, e.clientY) as HTMLElement | null;
      const ne = t?.closest<HTMLElement>(".sdc-o");
      if (ne && ne.dataset.id !== tu) noi(tu, ne.dataset.id!);
      else if (ne) thongBao(`Không nối ô “${tenId(tu)}” với chính nó.`, "warn");
      else if (t && vp.contains(t)) { const w = thanhToaDo(e.clientX, e.clientY); moMenuThem({ cx: e.clientX, cy: e.clientY, nguon: tu, viTri: { x: Math.round(w.x + 24), y: Math.round(w.y - H / 2) } }); }
    }
  }
  nghe(vp, "pointerup", (e: PointerEvent) => ketThucCon(e, false));
  nghe(vp, "pointercancel", (e: PointerEvent) => ketThucCon(e, true));
  nghe(vp, "lostpointercapture", (e: PointerEvent) => { ptrs.delete(e.pointerId); });
  nghe(vp, "wheel", (e: WheelEvent) => {
    e.preventDefault();
    const dy = e.deltaMode === 1 ? e.deltaY * 33 : e.deltaY;
    const r = vpRect();
    datView(zoomQuanh(view, e.clientX - r.left, e.clientY - r.top, Math.exp(-dy * 0.0016)));
  }, { passive: false });
  nghe(vp, "scroll", () => { vp.scrollLeft = 0; vp.scrollTop = 0; });
  nghe(vp, "click", (e: MouseEvent) => {
    const t = e.target as HTMLElement;
    const xb = t.closest<HTMLElement>(".sdc-xoa");
    if (xb) { if (!chiDoc() && xb.dataset.id) { const id = xb.dataset.id; if (!(xoaCuoi.id === id && performance.now() - xoaCuoi.t < 400)) xoaNutNgay(id); } return; }
    const ln = t.closest<HTMLElement>(".sdc-lap-nhan, .sdc-hit-lap");
    if (ln) { const c = tt.lap.find((x) => khoaLap(x) === ln.getAttribute("data-lap")); if (c) moHopLap(c.tu, c.den, ln as HTMLElement); return; }
    const hit = t.closest<SVGElement>(".sdc-hit");
    const nut = t.closest<HTMLButtonElement>(".sdc-canh-them");
    const key = hit?.getAttribute("data-canh") ?? nut?.dataset.canh;
    if (key) {
      const c = tt.canh.find((x) => khoaCanh(x) === key); if (!c) return;
      if (nut) { const r = nut.getBoundingClientRect(); moMenuCanh(c, r.left + r.width / 2, r.bottom, nut); } else moMenuCanh(c, e.clientX, e.clientY);
      return;
    }
    if (t.closest(".sdc-more") && sel) { const r = nutMore.getBoundingClientRect(); moMenuO(sel, r.left, r.bottom, nutMore); }
  });
  nghe(vp, "contextmenu", (e: MouseEvent) => {
    const el = (e.target as HTMLElement).closest<HTMLElement>(".sdc-o");
    if (!el) return;
    e.preventDefault(); chon(el.dataset.id!); moMenuO(el.dataset.id!, e.clientX, e.clientY, el);
  });
  // chú giải cờ: một tooltip dùng chung, đặt theo toạ độ màn hình (không bị thu nhỏ theo zoom, không bị cắt)
  function hienTip(id: string): void {
    const cb = canhBaoCua(id), co = mucCo(cb), el = elNut.get(id)?.el;
    if (!co || !el || keoId) { an(); return; }
    tip.replaceChildren(h("b", { class: co === "do" ? "do" : "vang" }, veCo(co), co === "do" ? "Ô đỏ — sẽ không chạy" : "Cờ vàng — nên xem lại"), ...cb.map((c) => h("div", { class: "sdc-tip-dong" }, c.loi)));
    tip.className = `sdc-tip ${co === "do" ? "t-do" : "t-vang"}`;
    tip.hidden = false;
    const s = stage.getBoundingClientRect(), r = el.getBoundingClientRect(), tr = tip.getBoundingClientRect();
    let x = r.left - s.left + r.width / 2 - tr.width / 2, y = r.top - s.top - tr.height - 10;
    if (y < 4) y = r.bottom - s.top + 10;
    x = Math.max(4, Math.min(x, s.width - tr.width - 4));
    tip.style.left = `${x}px`; tip.style.top = `${Math.max(4, y)}px`;
    tip.dataset.nut = id;
  }
  function an(): void { if (!tip.hidden) { tip.hidden = true; delete tip.dataset.nut; } }
  nghe(boxNut, "pointerover", (e: PointerEvent) => { if (e.pointerType === "touch" || che) return; const el = (e.target as HTMLElement).closest<HTMLElement>(".sdc-o"); if (el && (el.dataset.co ?? "")) hienTip(el.dataset.id!); });
  nghe(boxNut, "pointerout", (e: PointerEvent) => { const el = (e.target as HTMLElement).closest<HTMLElement>(".sdc-o"); const den = (e.relatedTarget as HTMLElement | null)?.closest?.(".sdc-o"); if (el && el !== den && document.activeElement !== el) an(); });

  // ---------- tiêu điểm ----------
  nghe(root, "focusin", (e: FocusEvent) => {
    const el = (e.target as HTMLElement).closest<HTMLElement>(".sdc-o");
    if (el) {
      const id = el.dataset.id!;
      chon(id);
      if (el.matches(":focus-visible")) { hienRoi(id); if (el.dataset.co) hienTip(id); }
    } else an();
  });
  nghe(root, "focusout", (e: FocusEvent) => { const el = (e.target as HTMLElement).closest<HTMLElement>(".sdc-o"); if (el && !(e.relatedTarget && el.contains(e.relatedTarget as Node))) an(); });

  // ---------- bàn phím ----------
  nghe(root, "keydown", (e: KeyboardEvent) => {
    const t = e.target as HTMLElement;
    if (menu.contains(t)) return; // menu có trình nghe riêng
    if (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
    if (e.key === "Escape") {
      if (che) { huyCuChi(); e.preventDefault(); return; }
      if (!menu.hidden) { dongMenu(); e.preventDefault(); return; }
      if (nguonNoi) { const s = nguonNoi; datNguonNoi(null); elNut.get(s)?.el.focus({ preventScroll: true }); e.preventDefault(); return; }
      if (!tip.hidden) { an(); return; }
      if (sel) { chon(null); }
      return;
    }
    if ((e.ctrlKey || e.metaKey) && !e.altKey) {
      const k = e.key.toLowerCase();
      if (k === "z" && !e.shiftKey) { e.preventDefault(); if (!chiDoc()) hoanTac(); return; }
      if (k === "y" || (k === "z" && e.shiftKey)) { e.preventDefault(); if (!chiDoc()) lamLai(); return; }
    }
    const el = t.closest<HTMLElement>(".sdc-o");
    if (!el || t !== el) return;
    const id = el.dataset.id!;
    const k = e.key;
    if (k === "Enter" || k === " ") { e.preventDefault(); moChiTiet(id); }
    else if (k === "ArrowLeft" || k === "ArrowRight" || k === "ArrowUp" || k === "ArrowDown") {
      e.preventDefault();
      if (chiDoc()) return;
      const b = e.shiftKey ? 40 : 10;
      const dx = k === "ArrowLeft" ? -b : k === "ArrowRight" ? b : 0, dy = k === "ArrowUp" ? -b : k === "ArrowDown" ? b : 0;
      // nhiều phím mũi tên liên tiếp (< 900 ms) vào cùng một ô gộp thành MỘT bước hoàn tác
      const now = performance.now();
      if (!(phimCuoi.id === id && now - phimCuoi.t < 900)) ghiLichSu();
      phimCuoi = { id, t: now };
      tt = { ...tt, boCuc: dichO(tt.boCuc, id, dx, dy) };
      datViTriEl(id); veCanhCuaO(id); capNhatNutMore(); veMini(); hienRoi(id);
      live.textContent = `Đã dời ${tenId(id)}`;
      phat(false, true);
    }
    else if (k === "Delete" || k === "Backspace") {
      e.preventDefault();
      // bấm Delete hai lần liên tiếp / giữ phím: chỉ xoá MỘT ô — lần Delete thứ hai rơi vào ô vừa được nhận tiêu điểm sau lần xoá trước (trong 400 ms) thì bỏ qua
      if (e.repeat || (xoaCuoi.id === id && performance.now() - xoaCuoi.t < 400)) return;
      xoaNutNgay(id);
    }
    else if (k === "n" || k === "N") { e.preventDefault(); moMenuNoiToi(id, el); }
    else if (k === "m" || k === "M" || k === "ContextMenu" || (k === "F10" && e.shiftKey)) { e.preventDefault(); const r = el.getBoundingClientRect(); moMenuO(id, r.left + 10, r.bottom, el); }
    else if ((k === "d" || k === "D") && (e.ctrlKey || e.metaKey)) { e.preventDefault(); nhanBanNgay(id); }
  });
  let phimCuoi = { id: "", t: 0 };
  let xoaCuoi = { t: -1e9, id: "" };

  // ---------- bản đồ nhỏ ----------
  {
    let dang = false;
    const di = (e: PointerEvent): void => {
      if (!miniBox) return;
      const r = miniSvg.getBoundingClientRect();
      const s = Math.min(r.width / miniBox.w, r.height / miniBox.h);
      if (!(s > 0)) return;
      const ox = (r.width - miniBox.w * s) / 2, oy = (r.height - miniBox.h * s) / 2;
      const wx = miniBox.x0 + (e.clientX - r.left - ox) / s, wy = miniBox.y0 + (e.clientY - r.top - oy) / s;
      const vr = vpRect();
      datView({ k: view.k, tx: vr.width / 2 - wx * view.k, ty: vr.height / 2 - wy * view.k });
    };
    nghe(miniSvg, "pointerdown", (e: PointerEvent) => { dang = true; try { miniSvg.setPointerCapture(e.pointerId); } catch { /* không bắt buộc */ } di(e); });
    nghe(miniSvg, "pointermove", (e: PointerEvent) => { if (dang) di(e); });
    nghe(miniSvg, "pointerup", () => { dang = false; });
    nghe(miniSvg, "pointercancel", () => { dang = false; });
  }

  // ---------- đổi cỡ khung ----------
  const ro = typeof ResizeObserver === "function" ? new ResizeObserver(() => {
    if (daHuy || cheDoDanhSach) return;
    const r = vpRect();
    if (!(r.width > 0 && r.height > 0)) return;
    if (choVuaKhung) vuaKhungNgay(); else veMini();
  }) : null;
  ro?.observe(vp);

  // ================= DANH SÁCH DỌC =================
  function veDanhSach(): void {
    const ds = thuTuDoc(tt.nut, tt.canh);
    sttDs = new Map(ds.map((x) => [x.nut.id, x.thuTu] as const));
    const nhom = new Map<number, typeof ds>();
    for (const x of ds) { const a = nhom.get(x.duong) ?? []; a.push(x); nhom.set(x.duong, a); }
    const phan: HTMLElement[] = [];
    for (const [d, ms] of nhom) {
      const li = ms.map((x) => muc2(x.nut, x.thuTu));
      phan.push(h("section", { class: "sdc-ds-duong", "aria-label": `Đường ${d}` }, h("h3", {}, `Đường ${d}`), h("ol", {}, ...li)));
    }
    dsEl.replaceChildren(...(phan.length ? phan : [h("p", { class: "sdc-trong" }, "Chưa có ô nào. Bấm “＋ Thêm ô”.")]));
  }
  let sttDs = new Map<string, number>();
  function muc2(n: NutDoThi, stt: number): HTMLElement {
    const mang = maMang(nenTangCua(n)), cb = canhBaoCua(n.id), co = mucCo(cb), sua = !chiDoc();
    const ra = tt.canh.find((c) => c.tu === n.id);
    const vl = tt.lap.find((c) => c.tu === n.id);
    const uocChu = uocChuCua(n);
    let tom = ""; try { tom = o.tomTatNut(n) ?? ""; } catch { tom = ""; }
    const lan = nhanLan(n.id);
    const nh = nhuongHL(n);
    const bt = (nhan: string, a: string, extra: Record<string, unknown> = {}): HTMLButtonElement => h("button", { type: "button", "data-a": a, title: nhan, ...extra }, nhan);
    const li = h("li", { class: `sdc-li ${lopCo(co)}${sel === n.id ? " sel" : ""}`, "data-id": n.id, "data-testid": "sdc-li" },
      h("span", { class: "sdc-idx" }, stt),
      h("div", { class: "sdc-li-chinh" },
        h("div", { class: "sdc-li-ten" },
          h("span", { class: `sdc-b b-${mang.ma}`, "aria-hidden": "true" }, mang.chu || "•"),
          h("b", {}, tenO(n)), lan ? h("span", { class: "sdc-lan sdc-lan-ds" }, lan) : null, mang.ten ? h("span", { class: "sdc-li-mang" }, mang.ten) : null,
          nh ? h("span", { class: "sdc-li-nhuong" }, "điểm nhường") : null,
          chuGan(n) ? h("span", { class: "sdc-li-gan", "data-testid": "sdc-li-gan" }, chuGan(n)) : null,
          co === "do" ? h("b", { class: "sdc-li-co do" }, veCo("do"), "Cờ đỏ") : co === "vang" ? h("b", { class: "sdc-li-co vang" }, veCo("vang"), "Cờ vàng") : null),
        h("div", { class: "sdc-li-tom" }, tom),
        cb.length ? h("div", { class: "sdc-li-vi" }, cb.map((c) => c.loi).join(" ")) : null,
        (() => { let c: string | null = null; try { c = o.loiChay?.(n.id) ?? null; } catch { c = null; } return c ? h("div", { class: "sdc-li-loi-chay", "data-testid": "sdc-li-loi-chay" }, h("b", {}, "✗ Lần chạy gần nhất lỗi: "), c) : null; })(),
        h("div", { class: "sdc-li-ra" }, ra ? `Rồi: → ${tenId(ra.den)}` : "Không nối đi đâu", uocChu ? h("span", { class: "sdc-li-uoc", "data-testid": "sdc-li-uoc" }, ` · ước chừng ${uocChu}`) : null),
        vl ? h("div", { class: "sdc-li-lap", "data-testid": "sdc-li-lap" }, `↺ quay lại bước ${sttDs.get(vl.den) ?? "?"} ${vl.denHetNghi ? "tới khi hết bước Nghỉ" : `×${vl.soLan}`}${vl.denGio ? ` · tới ${vl.denGio}` : ""}`) : null,
        h("div", { class: "sdc-li-nut" },
          bt(sua ? "Sửa chi tiết" : "Xem chi tiết", "ct"),
          ...(sua ? [
            bt("Nối tới…", "noi"), ...(ra ? [bt("Gỡ nối tiếp", "go")] : []), ...(vl ? [bt("Sửa vòng", "lap")] : []), bt("Chèn ô sau", "sau"), bt("Nhân bản", "nb"),
            ...(laNghi(n) ? [bt(`Nhường: ${nh ? "Bật" : "Tắt"}`, "nhuong", { "aria-pressed": String(nh) })] : []),
            bt("Xoá", "xoa", { class: "sdc-nguy" }),
          ] : []))));
    return li;
  }
  nghe(dsEl, "click", (e: MouseEvent) => {
    const b = (e.target as HTMLElement).closest<HTMLButtonElement>("button[data-a]"); if (!b) return;
    const li = b.closest<HTMLElement>(".sdc-li"); const id = li?.dataset.id; if (!id) return;
    chon(id);
    const a = b.dataset.a;
    if (a === "ct") moChiTiet(id);
    else if (a === "noi") moMenuNoiToi(id, b);
    else if (a === "go") { const c = tt.canh.find((x) => x.tu === id); if (c) goNoi(c); }
    else if (a === "lap") { const c = tt.lap.find((x) => x.tu === id); if (c) moHopLap(c.tu, c.den, b); }
    else if (a === "sau") { const r = b.getBoundingClientRect(); moMenuThem({ cx: r.left, cy: r.bottom, nguon: id, trove: b }); }
    else if (a === "nb") nhanBanNgay(id);
    else if (a === "nhuong") doiNhuongNgay(id);
    else if (a === "xoa") xoaNutNgay(id);
  });
  function datCheDo(ds: boolean): void {
    if (ds === cheDoDanhSach) return;
    cheDoDanhSach = ds;
    dongMenu(false); an();
    veNutLenh();
    if (ds) veDanhSach();
    else { veTatCa(true); datView(view); if (choVuaKhung) vuaKhungNgay(); }
  }

  // ================= NẠP DỮ LIỆU =================
  /** Lần đầu: nạp từ `o`. Về sau (capNhat) chỉ khoá NÀO được đưa vào mới thay; khoá không đưa thì GIỮ bản đang có — nếu không, trang chủ gọi capNhat({nut}) sau khi người dùng vừa nối / kéo ô sẽ làm mất nối / bố cục đó. */
  function nap(moi?: Partial<TuyChonSoDoCanvas>): void {
    const dau = moi === undefined;
    const nut = dau || moi.nut !== undefined ? (o.nut ?? []).map((n) => ({ ...n, thamSo: { ...(n.thamSo ?? {}) } })) : tt.nut;
    const canh = chuanHoaCanh(nut, dau ? o.canh : moi.canh !== undefined ? moi.canh : tt.canh).canh;
    const boCuc = datViTriThieu(nut, canh, dau ? o.boCuc : moi.boCuc !== undefined ? moi.boCuc : tt.boCuc);
    const lap = chuanHoaLap(nut, canh, dau ? o.lap : moi.lap !== undefined ? moi.lap : tt.lap).lap;
    if (dau || moi.lapCaSoDo !== undefined) lapCa = o.lapCaSoDo ? { ...o.lapCaSoDo } : null;
    tt = { nut, canh, boCuc, lap };
    if (sel && !nut.some((n) => n.id === sel)) sel = null;
    if (nguonNoi && !nut.some((n) => n.id === nguonNoi)) datNguonNoi(null);
  }

  // ================= API =================
  const api: SoDoCanvas = {
    capNhat(moi) {
      if (daHuy) return;
      o = { ...o, ...moi };
      huyTween(true);
      nap(moi);
      const ep = moi.canhBao !== undefined || moi.tomTatNut !== undefined || moi.tenNut !== undefined || moi.danhNhan !== undefined || moi.thaoTacMang !== undefined || moi.chiDoc !== undefined || moi.laNghi !== undefined || moi.bieuTuong !== undefined || moi.nhuongMacDinh !== undefined || moi.nenTangMacDinh !== undefined || moi.uocNut !== undefined || moi.lap !== undefined;
      if (moi.danhSachDoc !== undefined) datCheDo(moi.danhSachDoc);
      if (moi.henGio !== undefined) henGioBox.replaceChildren(...(o.henGio ? [o.henGio] : []));
      henGioBox.hidden = !o.henGio || o.chiDoc === true;
      // luôn vẽ lại nội dung từng ô khi trang chủ gọi capNhat (cờ / tóm tắt có thể đổi dù nut giữ nguyên tham chiếu); veNut tự bỏ qua ô không đổi chữ ký
      veTatCa(ep);
      if (choVuaKhung) vuaKhungNgay();
      veNutLenh();
    },
    chonNut: chonNutNgoai,
    dongBo() { if (daHuy) return; huyTween(true); nap({}); veTatCa(true); datView(view); },
    huy() {
      if (daHuy) return;
      daHuy = true;
      huyTween(false);
      if (miniRaf) cancelAnimationFrame(miniRaf);
      window.clearTimeout(snackHen);
      for (const t of hen) window.clearTimeout(t);
      ro?.disconnect();
      for (const f of dangKy.splice(0)) f();
      ptrs.clear();
      root.remove();
      elNut.clear(); elCanh.clear(); elLap.clear();
    },
    laySoDoDoc() { veDanhSach(); return dsEl; },
    vuaKhung() { if (cheDoDanhSach) datCheDo(false); lanDauVua = false; vuaKhungNgay(); },
    tuDan() { tuDanNgay(); },
    hoanTac, lamLai,
    layBoCuc: () => JSON.parse(JSON.stringify(tt.boCuc)) as BoCuc,
    layCanh: () => tt.canh.map((c) => ({ ...c })),
    layLap: () => tt.lap.map((c) => ({ ...c })),
    layLapCaSoDo: () => (lapCa ? { ...lapCa } : null),
    layNut: () => JSON.parse(JSON.stringify(tt.nut)) as NutDoThi[],
    layView: () => ({ ...view }),
  };

  // ---------- khởi động ----------
  nap();
  cheDoDanhSach = o.danhSachDoc ?? (window.matchMedia?.("(max-width: 640px)").matches ?? false);
  veTatCa(true);
  datView(view);
  if (cheDoDanhSach) veDanhSach();
  else requestAnimationFrame(() => { if (!daHuy && choVuaKhung) vuaKhungNgay(); });
  return api;
}
